import "./style.css";
import { defineComponent as y, openBlock as d, createElementBlock as h, Fragment as I, createBlock as S, resolveDynamicComponent as X, mergeProps as $, toHandlers as L, withCtx as O, renderSlot as N, resolveComponent as k, createTextVNode as Vt, toDisplayString as ce, defineAsyncComponent as Y, createVNode as E, renderList as F, createCommentVNode as C, h as ze, createElementVNode as z, normalizeStyle as M, normalizeClass as Z, markRaw as Nt } from "vue";
const xt = /* @__PURE__ */ new Set(["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"]), Wt = (e) => typeof e == "string" && xt.has(e.toLowerCase());
function x(e = {}, t, n) {
  const o = {};
  for (const r in e) {
    if (!e[r] || n && !r.startsWith(t))
      continue;
    const i = n ? r.replace(t, "") : r;
    o[i] = e[r];
  }
  return o;
}
const Dt = y({
  name: "dynamic-renderer",
  props: ["TagName", "attributes", "actionAttributes"],
  data() {
    return { isEmptyElement: Wt };
  }
}), v = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
};
function Ot(e, t, n, o, r, i) {
  return e.isEmptyElement(e.TagName) ? (d(), S(X(e.TagName), $({ key: 1 }, e.attributes, L(e.actionAttributes)), null, 16)) : (d(), h(I, { key: 0 }, [
    typeof e.TagName == "string" ? (d(), S(X(e.TagName), $({ key: 0 }, e.attributes, L(e.actionAttributes)), {
      default: O(() => [
        N(e.$slots, "default")
      ]),
      _: 3
    }, 16)) : (d(), S(X(e.TagName), $({ key: 1 }, e.attributes, L(e.actionAttributes)), {
      default: O(() => [
        N(e.$slots, "default")
      ]),
      _: 3
    }, 16))
  ], 64));
}
const ke = /* @__PURE__ */ v(Dt, [["render", Ot]]), vs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ke
}, Symbol.toStringTag, { value: "Module" })), R = "vue", j = () => {
  switch (R) {
    case "react":
    case "reactNative":
    case "rsc":
      return "className";
    case "svelte":
    case "vue":
    case "solid":
    case "qwik":
    case "angular":
      return "class";
  }
}, Ut = y({
  name: "builder-button",
  components: { DynamicRenderer: ke },
  props: [
    "attributes",
    "link",
    "openLinkInNewTab",
    "builderLinkComponent",
    "text"
  ],
  data() {
    return { filterAttrs: x };
  },
  methods: {
    attrs() {
      return {
        ...x(this.attributes, "v-on:", !1),
        [j()]: `${this.link ? "" : "builder-button"} ${this.attributes[j()] || ""}`,
        ...this.link ? {
          href: this.link,
          target: this.openLinkInNewTab ? "_blank" : void 0,
          role: "link"
        } : {
          role: "button"
        }
      };
    }
  }
});
function Lt(e, t, n, o, r, i) {
  const s = k("DynamicRenderer");
  return d(), S(s, {
    attributes: e.attrs(),
    TagName: e.link ? e.builderLinkComponent || "a" : "button",
    actionAttributes: e.filterAttrs(e.attributes, "v-on:", !0)
  }, {
    default: O(() => [
      Vt(ce(e.text), 1)
    ]),
    _: 1
  }, 8, ["attributes", "TagName", "actionAttributes"]);
}
const Ft = /* @__PURE__ */ v(Ut, [["render", Lt]]), Ht = Symbol(), be = {
  Builder: {
    content: null,
    context: {},
    localState: void 0,
    rootSetState() {
    },
    rootState: {},
    apiKey: null,
    apiVersion: void 0,
    componentInfos: {},
    inheritedStyles: {},
    BlocksWrapper: "div",
    BlocksWrapperProps: {},
    nonce: "",
    model: ""
  },
  key: Ht
}, Mt = Symbol(), Ge = {
  Components: { registeredComponents: {} },
  key: Mt
}, ne = "[Builder.io]: ", B = {
  log: (...e) => console.log(ne, ...e),
  error: (...e) => console.error(ne, ...e),
  warn: (...e) => console.warn(ne, ...e),
  debug: (...e) => console.debug(ne, ...e)
}, Je = (e, t, n) => {
  const o = String.prototype.split.call(t, /[,[\].]+?/).filter(Boolean).reduce((r, i) => r != null ? r[i] : r, e);
  return o === void 0 || o === e ? n : o;
};
function T() {
  return typeof window < "u" && typeof document < "u";
}
const jt = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[o] = n;
  }), t;
}, Qe = (e) => e instanceof URLSearchParams ? jt(e) : e, Ye = (e) => typeof e == "string" ? e : e instanceof URLSearchParams ? e.toString() : new URLSearchParams(e).toString();
function Kt() {
  return T() && window.self !== window.top;
}
function A(e) {
  return Kt() && // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  Ye(e || window.location.search).indexOf("builder.frameEditing=") !== -1;
}
const qt = () => {
  if (T()) {
    const e = new URL(location.href);
    return e.pathname === "" && (e.pathname = "/"), e;
  } else
    return console.warn("Cannot get location for tracking in non-browser environment"), null;
}, zt = () => typeof navigator == "object" && navigator.userAgent || "", Xe = () => {
  const e = zt(), t = {
    Android() {
      return e.match(/Android/i);
    },
    BlackBerry() {
      return e.match(/BlackBerry/i);
    },
    iOS() {
      return e.match(/iPhone|iPod/i);
    },
    Opera() {
      return e.match(/Opera Mini/i);
    },
    Windows() {
      return e.match(/IEMobile/i) || e.match(/WPDesktop/i);
    },
    any() {
      return t.Android() || t.BlackBerry() || t.iOS() || t.Opera() || t.Windows() || R === "reactNative";
    }
  }, n = e.match(/Tablet|iPad/i), o = qt();
  return {
    urlPath: o == null ? void 0 : o.pathname,
    host: (o == null ? void 0 : o.host) || (o == null ? void 0 : o.hostname),
    device: n ? "tablet" : t.any() ? "mobile" : "desktop"
  };
}, Gt = ({
  builder: e,
  context: t,
  event: n,
  state: o
}) => Object.entries({
  state: o,
  Builder: e,
  // legacy
  builder: e,
  context: t,
  event: n
}), Jt = () => ({
  isEditing: A(),
  isBrowser: T(),
  isServer: !T(),
  getUserAttributes: () => Xe()
}), Qt = (e, {
  isExpression: t = !0
}) => /* we disable this for cases where we definitely don't want a return */ t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) ? `return (${e});` : e;
function _e({
  rootState: e,
  localState: t,
  rootSetState: n
}) {
  return new Proxy(e, {
    get: (o, r) => {
      if (t && r in t)
        return t[r];
      const i = o[r];
      return typeof i == "object" && i !== null ? _e({
        rootState: i,
        localState: void 0,
        rootSetState: n ? (s) => {
          o[r] = s, n(o);
        } : void 0
      }) : i;
    },
    set: (o, r, i) => {
      if (t && r in t)
        throw new Error("Writing to local state is not allowed as it is read-only.");
      return o[r] = i, n == null || n(o), !0;
    }
  });
}
const xe = ({
  code: e,
  builder: t,
  context: n,
  event: o,
  localState: r,
  rootSetState: i,
  rootState: s
}) => {
  const l = Gt({
    builder: t,
    context: n,
    event: o,
    state: _e({
      rootState: s,
      localState: r,
      rootSetState: i
    })
  });
  return new Function(...l.map(([a]) => a), e)(...l.map(([, a]) => a));
}, K = (e) => e != null;
function Yt() {
  var e;
  return typeof process < "u" && K((e = process == null ? void 0 : process.versions) == null ? void 0 : e.node);
}
const Xt = ({
  shouldLogWarning: e
}) => {
  var r;
  if (!Yt())
    return !1;
  const t = process.arch === "arm64", n = process.version.startsWith("v20"), o = (r = process.env.NODE_OPTIONS) == null ? void 0 : r.includes("--no-node-snapshot");
  return t && n && !o ? (e && B.log("Skipping usage of `isolated-vm` to avoid crashes in Node v20 on an arm64 machine.\n    If you would like to use the `isolated-vm` package on this machine, please provide the `NODE_OPTIONS=--no-node-snapshot` config to your Node process.\n    See https://github.com/BuilderIO/builder/blob/main/packages/sdks/README.md#node-v20--m1-macs-apple-silicon-support for more information.\n    "), !0) : !1;
}, _t = (e) => (T() || Xt({
  shouldLogWarning: !0
}), xe(e)), Zt = /^(return )?(\s*)?state(?<getPath>(\.\w+)+)(\s*);?$/, en = /(\s)*var(\s)+_virtual_index(\s)*=(\s)*state(?<getPath>(\.\w+)+)(\s*);?(\s)*return(\s)*_virtual_index(\s)*/, tn = (e) => {
  var t, n, o, r, i, s;
  return ((o = (n = (t = Zt.exec(e.trim())) == null ? void 0 : t.groups) == null ? void 0 : n.getPath) == null ? void 0 : o.slice(1)) || ((s = (i = (r = en.exec(e.trim())) == null ? void 0 : r.groups) == null ? void 0 : i.getPath) == null ? void 0 : s.slice(1));
};
function ee({
  code: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: r,
  event: i,
  isExpression: s = !0
}) {
  if (e.trim() === "")
    return;
  const l = tn(e.trim());
  if (l)
    return Je({
      ...o,
      ...n
    }, l);
  const a = {
    code: Qt(e, {
      isExpression: s
    }),
    builder: Jt(),
    context: t,
    event: i,
    rootSetState: r,
    rootState: o,
    localState: n
  };
  try {
    return _t(a);
  } catch (u) {
    B.error("Failed code evaluation: " + u.message, {
      code: e
    });
    return;
  }
}
function nn(e, t) {
  var n;
  return {
    ...(n = e.component) == null ? void 0 : n.options,
    ...e.options,
    ...on(e, t)
  };
}
const on = (e, t) => {
  var n, o;
  if (((n = e.component) == null ? void 0 : n.name) === "Text" && ((o = e.component.options) != null && o.text) && typeof e.component.options.text == "string")
    return {
      ...e.component.options,
      text: e.component.options.text.replace(/{{([^}]+)}}/g, (r, i) => ee({
        code: i,
        context: t,
        localState: t.localState,
        rootState: t.rootState,
        rootSetState: t.rootSetState
      }))
    };
};
function rn(e, ...t) {
  const n = Object.assign({}, e);
  for (const o of t)
    delete n[o];
  return n;
}
function se(e, t, n = null, o = null, r = /* @__PURE__ */ new WeakSet()) {
  if (e == null || typeof e != "object") {
    t(e, (i) => {
      n !== null && o !== null && (n[o] = i);
    });
    return;
  }
  r.has(e) || (r.add(e), Array.isArray(e) ? e.forEach((i, s) => {
    t(i, (a) => {
      e[s] = a;
    }), se(i, t, e, s, r);
  }) : Object.entries(e).forEach(([i, s]) => {
    t(s, (a) => {
      e[i] = a;
    }), se(s, t, e, i, r);
  }));
}
function Ze(e) {
  return e && typeof e == "object" && e["@type"] === "@builder.io/core:LocalizedValue";
}
function sn(e) {
  if (!e || !Object.getOwnPropertyNames(e).length)
    return !1;
  let t = !1;
  return se(e, (n) => {
    if (Ze(n)) {
      t = !0;
      return;
    }
  }), t;
}
function an(e, t) {
  return !e || !Object.getOwnPropertyNames(e).length ? {} : (se(e, (n, o) => {
    Ze(n) && o(n[t] ?? void 0);
  }), e);
}
function ln(e, t) {
  var n, o;
  return (n = e.component) != null && n.options && sn((o = e.component) == null ? void 0 : o.options) && (t || console.warn("[Builder.io] In order to use localized fields in Builder, you must pass a locale prop to the BuilderComponent or to options object while fetching the content to resolve localized fields. Learn more: https://www.builder.io/c/docs/localization-inline#targeting-and-inline-localization"), e.component.options = an(e.component.options, t ?? "Default")), e;
}
const Ce = (e) => JSON.parse(JSON.stringify(e)), et = (e, t, n) => {
  if (Object(e) !== e)
    return e;
  const o = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
  return o.slice(0, -1).reduce((r, i, s) => Object(r[i]) === r[i] ? r[i] : r[i] = Math.abs(Number(o[s + 1])) >> 0 === +o[s + 1] ? [] : {}, e)[o[o.length - 1]] = n, e;
};
function ge(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map((n) => ge(n));
  if (e["@type"] === "@builder.io/sdk:Element")
    return e;
  const t = {};
  for (const n in e)
    n !== "meta" && Object.prototype.hasOwnProperty.call(e, n) && (t[n] = ge(e[n]));
  return t;
}
const cn = ["svelte", "vue", "angular", "qwik", "solid"].includes(R), dn = (e) => {
  if (cn) {
    const t = Ce(e);
    return {
      ...t,
      properties: {
        ...t.properties
      },
      actions: {
        ...t.actions
      }
    };
  } else {
    const t = ge(rn(e, "children", "meta"));
    return {
      ...t,
      properties: {
        ...t.properties
      },
      actions: {
        ...t.actions
      },
      children: e.children,
      meta: e.meta
    };
  }
}, un = ({
  block: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: r
}) => {
  if (!e.bindings)
    return e;
  const i = dn(e);
  for (const s in e.bindings) {
    const l = e.bindings[s], a = ee({
      code: l,
      localState: n,
      rootState: o,
      rootSetState: r,
      context: t
    });
    et(i, s, a);
  }
  return i;
};
function pn({
  block: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: r
}) {
  let i = e;
  return i = un({
    block: i,
    localState: n,
    rootState: o,
    rootSetState: r,
    context: t
  }), i = ln(i, o.locale), i;
}
function Te(e) {
  const t = e || (T() ? window.location.search : void 0);
  return t ? Ye(t).indexOf("builder.preview=") !== -1 : !1;
}
const mn = (e) => ({
  type: "builder.registerComponent",
  data: ae(e)
}), hn = (e) => {
  const t = e.toString().trim(), n = /^[a-zA-Z0-9_]+\s*=>/i.test(t);
  return `return (${!t.startsWith("function") && !t.startsWith("async") && !t.startsWith("(") && !n ? "function " : ""}${t}).apply(this, arguments)`;
};
function ae(e) {
  return JSON.parse(JSON.stringify(e, (t, n) => typeof n == "function" ? hn(n) : n));
}
const We = {};
function Ss(e, t) {
  e === "plugin" && (t = ae(t));
  let n = We[e];
  if (n || (n = We[e] = []), n.push(t), T()) {
    const o = {
      type: "builder.register",
      data: {
        type: e,
        info: t
      }
    };
    try {
      parent.postMessage(o, "*"), parent !== window && window.postMessage(o, "*");
    } catch (r) {
      console.debug("Could not postmessage", r);
    }
  }
}
function ks(e) {
  var t;
  if (T()) {
    const n = JSON.parse(JSON.stringify(e));
    e.action && (n.action = e.action.toString()), (t = window.parent) == null || t.postMessage({
      type: "builder.registerAction",
      data: n
    }, "*");
  }
}
const De = {};
function Cs(e) {
  if (T()) {
    Object.assign(De, e);
    const t = {
      type: "builder.settingsChange",
      data: De
    };
    parent.postMessage(t, "*");
  }
}
const Oe = "builder.", fn = "options.", tt = (e) => {
  if (!e)
    return {};
  const t = Qe(e), n = {};
  return Object.keys(t).forEach((o) => {
    if (o.startsWith(Oe)) {
      const r = o.replace(Oe, "").replace(fn, "");
      n[r] = t[o];
    }
  }), n;
}, bn = () => {
  if (!T())
    return {};
  const e = new URLSearchParams(window.location.search);
  return tt(e);
}, nt = "4.2.4", ot = () => ({
  "X-Builder-SDK": R,
  "X-Builder-SDK-GEN": "2",
  "X-Builder-SDK-Version": nt
}), gn = (e) => {
  if (e === "localhost" || e === "127.0.0.1")
    return e;
  const t = e.split(".");
  return t.length > 2 ? t.slice(1).join(".") : e;
}, de = ({
  name: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = document.cookie.split("; ").find((o) => o.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (o) {
    B.warn("[COOKIE] GET error: ", (o == null ? void 0 : o.message) || o);
    return;
  }
}, rt = async (e) => de(e), yn = (e) => e.map(([t, n]) => n ? `${t}=${n}` : t).filter(K).join("; "), vn = [["secure", ""], ["SameSite", "None"]], Sn = ({
  name: e,
  value: t,
  expires: n
}) => {
  const r = (T() ? location.protocol === "https:" : !0) ? vn : [[]], i = n ? [["expires", n.toUTCString()]] : [[]], s = [[e, t], ...i, ["path", "/"], ["domain", gn(window.location.hostname)], ...r];
  return yn(s);
}, we = async ({
  name: e,
  value: t,
  expires: n,
  canTrack: o
}) => {
  try {
    if (!o)
      return;
    const r = Sn({
      name: e,
      value: t,
      expires: n
    });
    document.cookie = r;
  } catch (r) {
    B.warn("[COOKIE] SET error: ", (r == null ? void 0 : r.message) || r);
  }
};
function kn() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
function it() {
  return kn().replace(/-/g, "");
}
const st = "builderSessionId", Cn = async ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = await rt({
    name: st,
    canTrack: e
  });
  if (K(t))
    return t;
  {
    const n = Tn();
    return wn({
      id: n,
      canTrack: e
    }), n;
  }
}, Tn = () => it(), wn = ({
  id: e,
  canTrack: t
}) => we({
  name: st,
  value: e,
  canTrack: t
}), at = () => T() && typeof localStorage < "u" ? localStorage : void 0, In = ({
  key: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = at()) == null ? void 0 : n.getItem(e) : void 0;
  } catch (o) {
    console.debug("[LocalStorage] GET error: ", o);
    return;
  }
}, $n = ({
  key: e,
  canTrack: t,
  value: n
}) => {
  var o;
  try {
    t && ((o = at()) == null || o.setItem(e, n));
  } catch (r) {
    console.debug("[LocalStorage] SET error: ", r);
  }
}, lt = "builderVisitorId", Rn = ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = In({
    key: lt,
    canTrack: e
  });
  if (K(t))
    return t;
  {
    const n = En();
    return An({
      id: n,
      canTrack: e
    }), n;
  }
}, En = () => it(), An = ({
  id: e,
  canTrack: t
}) => $n({
  key: lt,
  value: e,
  canTrack: t
});
function Ie(e) {
  var t;
  typeof process < "u" && ((t = process.env) != null && t.DEBUG) && String(process.env.DEBUG) == "true" && B.log(e);
}
const Pn = async ({
  canTrack: e
}) => {
  if (!e)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const t = await Cn({
    canTrack: e
  }), n = Rn({
    canTrack: e
  });
  return {
    sessionId: t,
    visitorId: n
  };
}, Bn = async ({
  type: e,
  canTrack: t,
  apiKey: n,
  metadata: o,
  ...r
}) => ({
  type: e,
  data: {
    ...r,
    metadata: {
      url: location.href,
      ...o
    },
    ...await Pn({
      canTrack: t
    }),
    userAttributes: Xe(),
    ownerId: n
  }
});
async function ye({
  apiHost: e,
  ...t
}) {
  if (!t.apiKey) {
    B.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (!t.canTrack || A() || !(T() || R === "reactNative"))
    return;
  const o = `${e || "https://cdn.builder.io"}/api/v1/track`;
  return Ie(o), fetch(o, {
    method: "POST",
    body: JSON.stringify({
      events: [await Bn(t)]
    }),
    headers: {
      "content-type": "application/json",
      ...ot()
    },
    mode: "cors"
  }).catch((r) => {
    console.error("Failed to track: ", r);
  });
}
const Ts = (e) => ye({
  ...e,
  canTrack: !0
}), Vn = ["*.beta.builder.io", "beta.builder.io", "builder.io", "localhost", "qa.builder.io"];
function ct(e, t) {
  if (!t.origin.startsWith("http") && !t.origin.startsWith("https"))
    return !1;
  const n = new URL(t.origin), o = n.hostname;
  return (e || Vn).findIndex((r) => r.startsWith("*.") ? o.endsWith(r.slice(1)) : r === o) > -1;
}
let Ue = !1;
const dt = (e) => {
  var t, n;
  Ue || (Ue = !0, T() && ((t = window.parent) == null || t.postMessage({
    type: "builder.sdkInfo",
    data: {
      target: R,
      version: nt,
      supportsPatchUpdates: !1,
      // Supports builder-model="..." attribute which is needed to
      // scope our '+ add block' button styling
      supportsAddBlockScoping: !0,
      supportsCustomBreakpoints: !0,
      modelName: e.modelName,
      apiKey: e.apiKey,
      supportsXSmallBreakpoint: !0,
      blockLevelPersonalization: !0
    }
  }, "*"), (n = window.parent) == null || n.postMessage({
    type: "builder.updateContent",
    data: {
      options: e
    }
  }, "*"), window.addEventListener("message", (o) => {
    var i, s;
    if (!ct(e.trustedHosts, o))
      return;
    const {
      data: r
    } = o;
    if (r != null && r.type)
      switch (r.type) {
        case "builder.evaluate": {
          const l = r.data.text, a = r.data.arguments || [], u = r.data.id, p = new Function(l);
          let f, c = null;
          try {
            f = p.apply(null, a);
          } catch (m) {
            c = m;
          }
          c ? (i = window.parent) == null || i.postMessage({
            type: "builder.evaluateError",
            data: {
              id: u,
              error: c.message
            }
          }, "*") : f && typeof f.then == "function" ? f.then((m) => {
            var b;
            (b = window.parent) == null || b.postMessage({
              type: "builder.evaluateResult",
              data: {
                id: u,
                result: m
              }
            }, "*");
          }).catch(console.error) : (s = window.parent) == null || s.postMessage({
            type: "builder.evaluateResult",
            data: {
              result: f,
              id: u
            }
          }, "*");
          break;
        }
      }
  })));
}, ut = ({
  model: e,
  trustedHosts: t,
  callbacks: n
}) => (o) => {
  if (!ct(t, o))
    return;
  const {
    data: r
  } = o;
  if (r)
    switch (r.type) {
      case "builder.configureSdk": {
        n.configureSdk(r.data);
        break;
      }
      case "builder.triggerAnimation": {
        n.animation(r.data);
        break;
      }
      case "builder.resetState": {
        const i = r.data, s = i.model, l = i == null ? void 0 : i.state, a = i.editType;
        s === e && l && n.stateUpdate(l, a);
        break;
      }
      case "builder.contentUpdate": {
        const i = r.data, s = i.key || i.alias || i.entry || i.modelName, l = i.data, a = i.editType;
        s === e && n.contentUpdate(l, a);
        break;
      }
    }
}, ws = ({
  model: e,
  apiKey: t,
  callback: n,
  trustedHosts: o
}) => {
  if (!T)
    return B.warn("`subscribeToEditor` only works in the browser. It currently seems to be running on the server."), () => {
    };
  dt({
    modelName: e,
    apiKey: t
  });
  const r = ut({
    callbacks: {
      contentUpdate: n,
      animation: () => {
      },
      configureSdk: () => {
      },
      stateUpdate: () => {
      }
    },
    model: e,
    trustedHosts: o
  });
  return window.addEventListener("message", r), () => {
    window.removeEventListener("message", r);
  };
}, Nn = "builder.tests", $e = (e) => `${Nn}.${e}`, xn = ({
  contentId: e
}) => rt({
  name: $e(e),
  canTrack: !0
}), Wn = ({
  contentId: e
}) => de({
  name: $e(e),
  canTrack: !0
}), Dn = ({
  contentId: e,
  value: t
}) => we({
  name: $e(e),
  value: t,
  canTrack: !0
}), pt = (e) => K(e.id) && K(e.variations) && Object.keys(e.variations).length > 0, On = ({
  id: e,
  variations: t
}) => {
  var r;
  let n = 0;
  const o = Math.random();
  for (const i in t) {
    const s = (r = t[i]) == null ? void 0 : r.testRatio;
    if (n += s, o < n)
      return i;
  }
  return e;
}, mt = (e) => {
  const t = On(e);
  return Dn({
    contentId: e.id,
    value: t
  }).catch((n) => {
    B.error("could not store A/B test variation: ", n);
  }), t;
}, ht = ({
  item: e,
  testGroupId: t
}) => {
  const n = e.variations[t];
  return t === e.id || // handle edge-case where `testGroupId` points to non-existing variation
  !n ? {
    testVariationId: e.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === e.id ? "Default" : "")
  };
}, Un = ({
  item: e,
  canTrack: t
}) => {
  if (!t)
    return e;
  if (!e)
    return;
  if (!pt(e))
    return e;
  const n = Wn({
    contentId: e.id
  }) || mt({
    variations: e.variations,
    id: e.id
  }), o = ht({
    item: e,
    testGroupId: n
  });
  return {
    ...e,
    ...o
  };
}, Ln = async ({
  item: e,
  canTrack: t
}) => {
  if (!t || !pt(e))
    return e;
  const o = await xn({
    contentId: e.id
  }) || mt({
    variations: e.variations,
    id: e.id
  }), r = ht({
    item: e,
    testGroupId: o
  });
  return {
    ...e,
    ...r
  };
};
const Le = "builder.userAttributes";
function Fe() {
  let e = !0;
  const t = /* @__PURE__ */ new Set();
  return {
    setUserAttributes(n) {
      if (!T())
        return;
      const o = {
        ...this.getUserAttributes(),
        ...n
      };
      we({
        name: Le,
        value: JSON.stringify(o),
        canTrack: e
      }), t.forEach((r) => r(o));
    },
    getUserAttributes() {
      return T() ? JSON.parse(de({
        name: Le,
        canTrack: e
      }) || "{}") : {};
    },
    subscribeOnUserAttributesChange(n, {
      fireImmediately: o
    } = {}) {
      return t.add(n), o && n(this.getUserAttributes()), function() {
        t.delete(n);
      };
    },
    setCanTrack(n) {
      e = n;
    }
  };
}
let ve;
T() && R === "qwik" ? (window.__BUILDER_USER_ATTRIBUTES_SERVICE__ || (window.__BUILDER_USER_ATTRIBUTES_SERVICE__ = Fe()), ve = window.__BUILDER_USER_ATTRIBUTES_SERVICE__) : ve = Fe();
const le = ve, Is = (e) => {
  le.setUserAttributes(e);
}, G = (e) => {
  const t = K(e) ? e : !0;
  return le.setCanTrack(t), t;
};
function Fn() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : globalThis;
}
function Hn() {
  const e = Fn().fetch;
  if (typeof e > "u")
    throw console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`), new Error("Builder SDK could not find a global `fetch` function");
  return e;
}
const Mn = Hn();
function Se(e, t = null, n = ".") {
  return Object.keys(e).reduce((o, r) => {
    const i = e[r], s = [t, r].filter(Boolean).join(n);
    return [typeof i == "object", i !== null, !(Array.isArray(i) && i.length === 0)].every(Boolean) ? {
      ...o,
      ...Se(i, s, n)
    } : {
      ...o,
      [s]: i
    };
  }, {});
}
function ft(e, t, n = {}) {
  for (const o in e) {
    const r = e[o], i = t ? t + "." + o : o;
    r && typeof r == "object" && !Array.isArray(r) && !Object.keys(r).find((s) => s.startsWith("$")) ? ft(r, i, n) : n[i] = r;
  }
  return n;
}
function jn(e) {
  const t = {};
  for (const n in e) {
    const o = n.split(".");
    let r = t;
    for (let i = 0; i < o.length; i++) {
      const s = o[i];
      i === o.length - 1 ? r[s] = e[n] : (r[s] = r[s] || {}, r = r[s]);
    }
  }
  return t;
}
const Kn = "v3", He = (e) => typeof e == "number" && !isNaN(e) && e >= 0, Re = (e) => {
  const {
    limit: t = 30,
    userAttributes: n,
    query: o,
    model: r,
    apiKey: i,
    enrich: s,
    locale: l,
    apiVersion: a = Kn,
    fields: u,
    omit: p,
    offset: f,
    cacheSeconds: c,
    staleCacheSeconds: m,
    sort: b,
    includeUnpublished: g,
    apiHost: P
  } = e;
  if (!i)
    throw new Error("Missing API key");
  if (!["v3"].includes(a))
    throw new Error(`Invalid apiVersion: expected 'v3', received '${a}'`);
  const U = t !== 1, V = P || "https://cdn.builder.io", w = new URL(`${V}/api/${a}/content/${r}`);
  w.searchParams.set("apiKey", i), w.searchParams.set("limit", String(t)), w.searchParams.set("noTraverse", String(U)), w.searchParams.set("includeRefs", String(!0)), l && w.searchParams.set("locale", l);
  let W = n || {};
  if (s && w.searchParams.set("enrich", String(s)), w.searchParams.set("omit", p ?? "meta.componentsUsed"), u && w.searchParams.set("fields", u), Number.isFinite(f) && f > -1 && w.searchParams.set("offset", String(Math.floor(f))), typeof g == "boolean" && w.searchParams.set("includeUnpublished", String(g)), c && He(c) && w.searchParams.set("cacheSeconds", String(c)), m && He(m) && w.searchParams.set("staleCacheSeconds", String(m)), b) {
    const D = Se({
      sort: b
    });
    for (const H in D)
      w.searchParams.set(H, JSON.stringify(D[H]));
  }
  const J = {
    ...bn(),
    ...Qe(e.options || {})
  };
  W = {
    ...W,
    ...zn(J)
  };
  const Q = Se(J);
  for (const D in Q)
    w.searchParams.set(D, String(Q[D]));
  if (Object.keys(W).length > 0 && w.searchParams.set("userAttributes", JSON.stringify(W)), o) {
    const D = ft({
      query: o
    });
    for (const H in D)
      w.searchParams.set(H, JSON.stringify(D[H]));
  }
  return w;
}, qn = (e) => {
  const t = {};
  for (const n in e)
    n.startsWith("userAttributes.") && (t[n] = e[n], delete e[n]);
  return t;
}, zn = (e) => {
  if (T() && e.preview === "BUILDER_STUDIO") {
    e["userAttributes.urlPath"] = window.location.pathname, e["userAttributes.host"] = window.location.host;
    const t = qn(e), {
      userAttributes: n
    } = jn(t);
    return n;
  }
  return {};
}, Gn = (e) => "results" in e;
async function Ee(e) {
  var o;
  const t = e.locale || ((o = e.userAttributes) == null ? void 0 : o.locale);
  t && (e.locale = t, e.userAttributes = {
    locale: t,
    ...e.userAttributes
  });
  const n = await Yn({
    ...e,
    limit: 1
  });
  return n && n[0] || null;
}
const Jn = async (e) => {
  var s;
  const t = Re(e), n = e.fetch ?? Mn, o = {
    ...e.fetchOptions,
    headers: {
      ...(s = e.fetchOptions) == null ? void 0 : s.headers,
      ...ot()
    }
  };
  return await (await n(t.href, o)).json();
}, Qn = async (e, t, n = Re(e)) => {
  const o = G(e.canTrack);
  if (n.search.includes("preview="), !o || !(T() || R === "reactNative"))
    return t.results;
  try {
    const r = [];
    for (const i of t.results)
      r.push(await Ln({
        item: i,
        canTrack: o
      }));
    t.results = r;
  } catch (r) {
    B.error("Could not process A/B tests. ", r);
  }
  return t.results;
};
async function Yn(e) {
  const t = Re(e), n = await Jn(e);
  if (!Gn(n))
    throw B.error("Error fetching data. ", {
      url: t,
      content: n,
      options: e
    }), n;
  return Qn(e, n);
}
const $s = async (e) => {
  var o, r, i;
  const t = e.path || ((o = e.url) == null ? void 0 : o.pathname) || ((r = e.userAttributes) == null ? void 0 : r.urlPath), n = {
    ...e,
    apiKey: e.apiKey,
    model: e.model || "page",
    userAttributes: {
      ...e.userAttributes,
      ...t ? {
        urlPath: t
      } : {}
    },
    options: tt(e.searchParams || ((i = e.url) == null ? void 0 : i.searchParams) || e.options)
  };
  return {
    apiKey: n.apiKey,
    model: n.model,
    content: await Ee(n)
  };
}, Ae = (e) => e ? e.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase() : "";
function Xn(e, t, n = {}) {
  let o, r, i, s = null, l = 0;
  const a = function() {
    l = n.leading === !1 ? 0 : Date.now(), s = null, i = e.apply(o, r), s || (o = r = null);
  };
  return function() {
    const u = Date.now();
    !l && n.leading === !1 && (l = u);
    const p = t - (u - l);
    return o = this, r = arguments, p <= 0 || p > t ? (s && (clearTimeout(s), s = null), l = u, i = e.apply(o, r), s || (o = r = null)) : !s && n.trailing !== !1 && (s = setTimeout(a, p)), i;
  };
}
function _(e, ...t) {
  const n = Object(e);
  for (let o = 1; o < arguments.length; o++) {
    const r = arguments[o];
    if (r != null)
      for (const i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }
  return n;
}
function _n(e) {
  for (const t of e)
    switch (t.trigger) {
      case "pageLoad":
        yt(t);
        break;
      case "scrollInView":
        eo(t);
        break;
    }
}
function bt(e) {
  console.warn(`Cannot animate element: element with ID ${e} not found!`);
}
function gt(e, t) {
  const n = Zn(e), o = getComputedStyle(t), r = e.steps[0].styles, i = e.steps[e.steps.length - 1].styles, s = [r, i];
  for (const l of s)
    for (const a of n)
      a in l || (l[a] = o[a]);
}
function Zn(e) {
  const t = [];
  for (const n of e.steps)
    for (const o in n.styles)
      t.indexOf(o) === -1 && t.push(o);
  return t;
}
function yt(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    bt(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    gt(e, n), n.style.transition = "none", n.style.transitionDelay = "0", _(n.style, e.steps[0].styles), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${Ae(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s"), _(n.style, e.steps[1].styles), setTimeout(() => {
        n.style.transition = "", n.style.transitionDelay = "";
      }, (e.delay || 0) * 1e3 + e.duration * 1e3 + 100);
    });
  });
}
function eo(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    bt(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    gt(e, n);
    let o = !1, r = !1;
    function i() {
      !o && l(n) ? (o = !0, r = !0, setTimeout(() => {
        _(n.style, e.steps[1].styles), e.repeat || document.removeEventListener("scroll", s), setTimeout(() => {
          r = !1, e.repeat || (n.style.transition = "", n.style.transitionDelay = "");
        }, (e.duration + (e.delay || 0)) * 1e3 + 100);
      })) : e.repeat && o && !r && !l(n) && (o = !1, _(n.style, e.steps[0].styles));
    }
    const s = Xn(i, 200, {
      leading: !1
    });
    function l(p) {
      const f = p.getBoundingClientRect(), c = window.innerHeight, b = (e.thresholdPercent || 0) / 100 * c;
      return f.bottom > b && f.top < c - b;
    }
    const a = e.steps[0].styles;
    function u() {
      _(n.style, a);
    }
    u(), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${Ae(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s");
    }), document.addEventListener("scroll", s, {
      capture: !0,
      passive: !0
    }), i();
  });
}
const vt = (e) => Object.entries(e).map(([n, o]) => {
  if (typeof o == "string")
    return `${Ae(n)}: ${o};`;
}).filter(K), to = (e) => vt(e).join(`
`), Rs = ({
  mediaQuery: e,
  className: t,
  styles: n
}) => {
  const o = `.${t} {
    ${to(n)}
  }`;
  return e ? `${e} {
      ${o}
    }` : o;
};
function no({
  style: e
}) {
  return e;
}
const Es = ({
  block: e,
  context: t
}) => St(no({
  style: e.style || {},
  context: t,
  block: e
}));
function St(e) {
  switch (R) {
    case "svelte":
    case "vue":
    case "solid":
    case "angular":
      return vt(e).join(" ");
    case "qwik":
    case "reactNative":
    case "react":
    case "rsc":
      return e;
  }
}
const kt = (e, t) => e ? t ? e.models && e.models.length > 0 && !e.models.includes(t) : !1 : !0, oo = ({
  block: e,
  registeredComponents: t,
  model: n
}) => {
  var i;
  const o = (i = e.component) == null ? void 0 : i.name;
  if (!o)
    return null;
  const r = t[o];
  if (!r || kt(r, n)) {
    console.warn(`
      Could not find a registered component named "${o}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
    return;
  } else
    return r;
}, ro = ({
  block: e,
  context: t
}) => {
  const {
    repeat: n,
    ...o
  } = e;
  if (!(n != null && n.collection))
    return;
  const r = ee({
    code: n.collection,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context
  });
  if (!Array.isArray(r))
    return;
  const i = n.collection.split(".").pop(), s = n.itemName || (i ? i + "Item" : "item");
  return r.map((a, u) => ({
    context: {
      ...t,
      localState: {
        ...t.localState,
        $index: u,
        $item: a,
        [s]: a,
        [`$${s}Index`]: u
      }
    },
    block: o
  }));
}, io = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderLinkComponent ? {
    builderLinkComponent: t
  } : {};
}, so = (e, t, n) => {
  var o;
  return (o = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && o.builderComponents ? {
    builderComponents: Object.fromEntries(Object.entries(t).filter(([i, s]) => !kt(s, n)))
  } : {};
}, ao = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderBlock ? {
    builderBlock: t
  } : {};
}, lo = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderContext ? {
    builderContext: t
  } : {};
}, co = (e) => e.toString(), uo = () => Promise.resolve().then(() => Io).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component DynamicDiv at ../dynamic-div.vue",
    e
  ), e;
}), po = () => import("./block-wrapper-nWZ8mnzV.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockWrapper at ./components/block-wrapper.vue",
    e
  ), e;
}), mo = () => import("./component-ref-809aE3jw.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component ComponentRef at ./components/component-ref/component-ref.vue",
    e
  ), e;
}), ho = () => import("./repeated-block-pz96mjT3.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component RepeatedBlock at ./components/repeated-block.vue",
    e
  ), e;
}), fo = () => import("./style-wrapper-XpqFC6zr.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component StyleWrapper at ./components/style-wrapper.vue",
    e
  ), e;
}), bo = y({
  name: "block",
  components: {
    StyleWrapper: Y(fo),
    RepeatedBlock: Y(ho),
    ComponentRef: Y(mo),
    BlockWrapper: Y(po),
    DynamicDiv: Y(uo)
  },
  props: ["block", "context", "registeredComponents", "linkComponent"],
  data() {
    return {
      _processedBlock: {
        value: null,
        update: !1
      },
      generateKey: co
    };
  },
  mounted() {
    const e = this.processedBlock.id, t = this.processedBlock.animations;
    t && e && _n(
      t.map((n) => ({
        ...n,
        elementId: e
      }))
    );
  },
  updated() {
  },
  computed: {
    repeatItem() {
      return ro({
        block: this.block,
        context: this.context
      });
    },
    processedBlock() {
      var t;
      return (t = this.block.repeat) != null && t.collection ? this.block : pn({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context
      });
    },
    blockComponent() {
      return oo({
        block: this.processedBlock,
        registeredComponents: this.registeredComponents,
        model: this.context.model
      });
    },
    Tag() {
      var t;
      return this.block.tagName === "a" || ((t = this.processedBlock.properties) == null ? void 0 : t.href) || this.processedBlock.href ? this.linkComponent || "a" : this.block.tagName || "div";
    },
    canShowBlock() {
      var n, o;
      if ((n = this.block.repeat) != null && n.collection)
        return !!((o = this.repeatItem) != null && o.length);
      const e = "hide" in this.processedBlock ? this.processedBlock.hide : !1;
      return ("show" in this.processedBlock ? this.processedBlock.show : !0) && !e;
    },
    childrenWithoutParentComponent() {
      var t;
      return !((t = this.blockComponent) != null && t.component) && !this.repeatItem ? this.processedBlock.children ?? [] : [];
    },
    componentRefProps() {
      var e, t, n;
      return {
        blockChildren: this.processedBlock.children ?? [],
        componentRef: (e = this.blockComponent) == null ? void 0 : e.component,
        componentOptions: {
          ...nn(this.processedBlock, this.context),
          ...ao(this.blockComponent, this.processedBlock),
          ...lo(this.blockComponent, this.context),
          ...io(this.blockComponent, this.linkComponent),
          ...so(
            this.blockComponent,
            this.registeredComponents,
            this.context.model
          )
        },
        context: this.context,
        linkComponent: this.linkComponent,
        registeredComponents: this.registeredComponents,
        builderBlock: this.processedBlock,
        includeBlockProps: ((t = this.blockComponent) == null ? void 0 : t.noWrap) === !0,
        isInteractive: !((n = this.blockComponent) != null && n.isRSC && R === "rsc")
      };
    }
  }
});
function go(e, t, n, o, r, i) {
  var f;
  const s = k("StyleWrapper"), l = k("ComponentRef"), a = k("Block", !0), u = k("BlockWrapper"), p = k("RepeatedBlock");
  return e.canShowBlock ? (d(), h(I, { key: 0 }, [
    E(s, {
      block: e.processedBlock,
      context: e.context,
      id: e.block.id
    }, null, 8, ["block", "context", "id"]),
    (f = e.blockComponent) != null && f.noWrap ? (d(), h(I, { key: 1 }, [
      e.repeatItem ? (d(!0), h(I, { key: 1 }, F(e.repeatItem, (c, m) => (d(), S(p, {
        key: e.generateKey(m),
        repeatContext: c.context,
        block: c.block,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["repeatContext", "block", "registeredComponents", "linkComponent"]))), 128)) : (d(), S(l, {
        key: 0,
        componentRef: e.componentRefProps.componentRef,
        componentOptions: e.componentRefProps.componentOptions,
        blockChildren: e.componentRefProps.blockChildren,
        context: e.componentRefProps.context,
        registeredComponents: e.componentRefProps.registeredComponents,
        linkComponent: e.componentRefProps.linkComponent,
        builderBlock: e.componentRefProps.builderBlock,
        includeBlockProps: e.componentRefProps.includeBlockProps,
        isInteractive: e.componentRefProps.isInteractive
      }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"]))
    ], 64)) : (d(), h(I, { key: 0 }, [
      e.repeatItem ? (d(!0), h(I, { key: 1 }, F(e.repeatItem, (c, m) => (d(), S(p, {
        key: e.generateKey(m),
        repeatContext: c.context,
        block: c.block,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["repeatContext", "block", "registeredComponents", "linkComponent"]))), 128)) : (d(), S(u, {
        key: 0,
        Wrapper: e.Tag,
        block: e.processedBlock,
        context: e.context
      }, {
        default: O(() => [
          E(l, {
            componentRef: e.componentRefProps.componentRef,
            componentOptions: e.componentRefProps.componentOptions,
            blockChildren: e.componentRefProps.blockChildren,
            context: e.componentRefProps.context,
            registeredComponents: e.componentRefProps.registeredComponents,
            linkComponent: e.componentRefProps.linkComponent,
            builderBlock: e.componentRefProps.builderBlock,
            includeBlockProps: e.componentRefProps.includeBlockProps,
            isInteractive: e.componentRefProps.isInteractive
          }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"]),
          (d(!0), h(I, null, F(e.childrenWithoutParentComponent, (c, m) => (d(), S(a, {
            key: c.id,
            block: c,
            registeredComponents: e.registeredComponents,
            linkComponent: e.linkComponent,
            context: e.context
          }, null, 8, ["block", "registeredComponents", "linkComponent", "context"]))), 128))
        ]),
        _: 1
      }, 8, ["Wrapper", "block", "context"]))
    ], 64))
  ], 64)) : C("", !0);
}
const Ct = /* @__PURE__ */ v(bo, [["render", go]]), As = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ct
}, Symbol.toStringTag, { value: "Module" })), yo = y({
  name: "builder-blocks-wrapper",
  props: [
    "blocks",
    "classNameProp",
    "path",
    "parent",
    "styleProp",
    "BlocksWrapperProps",
    "BlocksWrapper"
  ],
  data() {
    return { shouldUpdate: !1 };
  },
  mounted() {
  },
  watch: {
    onUpdateHook0: { handler() {
    }, immediate: !0 }
  },
  computed: {
    className() {
      var e;
      return [
        "builder-blocks",
        (e = this.blocks) != null && e.length ? "" : "no-blocks",
        this.classNameProp
      ].filter(Boolean).join(" ");
    },
    dataPath() {
      if (!this.path)
        return;
      const e = "this.", t = "component.options.";
      return this.path.startsWith(e) ? this.path.replace(e, "") : this.path.startsWith(t) ? this.path : `${t}${this.path || ""}`;
    },
    onUpdateHook0() {
      return {
        0: this.blocks
      };
    }
  },
  methods: {
    onClick() {
      var e, t;
      A() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.dataPath
          }
        },
        "*"
      ));
    },
    onMouseEnter() {
      var e, t;
      A() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.dataPath
          }
        },
        "*"
      ));
    }
  }
});
function vo(e, t, n, o, r, i) {
  return d(), S(X(e.BlocksWrapper), $({
    ref: "blocksWrapperRef",
    class: e.className + " component-5vz8uirn7sc",
    "builder-path": e.dataPath,
    "builder-parent-id": e.parent,
    style: e.styleProp,
    onClick: (s) => e.onClick(),
    onMouseEnter: (s) => e.onMouseEnter(),
    onKeyPress: (s) => e.onClick()
  }, { ...e.BlocksWrapperProps }), {
    default: O(() => [
      N(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16, ["class", "builder-path", "builder-parent-id", "style", "onClick", "onMouseEnter", "onKeyPress"]);
}
const So = /* @__PURE__ */ v(yo, [["render", vo], ["__scopeId", "data-v-82fc93d6"]]), ko = y({
  name: "builder-blocks",
  components: { BlocksWrapper: So, Block: Ct },
  props: [
    "blocks",
    "parent",
    "path",
    "styleProp",
    "BlocksWrapperProps",
    "context",
    "className",
    "linkComponent",
    "registeredComponents"
  ],
  inject: {
    builderContext: be.key,
    componentsContext: Ge.key
  }
});
function Co(e, t, n, o, r, i) {
  var a, u, p, f;
  const s = k("Block"), l = k("BlocksWrapper");
  return d(), S(l, {
    blocks: e.blocks,
    parent: e.parent,
    path: e.path,
    styleProp: e.styleProp,
    BlocksWrapperProps: e.BlocksWrapperProps || ((a = e.context) == null ? void 0 : a.BlocksWrapperProps) || ((u = e.builderContext) == null ? void 0 : u.BlocksWrapperProps),
    classNameProp: e.className,
    BlocksWrapper: ((p = e.context) == null ? void 0 : p.BlocksWrapper) || ((f = e.builderContext) == null ? void 0 : f.BlocksWrapper)
  }, {
    default: O(() => [
      N(e.$slots, "default"),
      e.blocks ? (d(!0), h(I, { key: 0 }, F(e.blocks, (c, m) => {
        var b;
        return d(), S(s, {
          key: c.id,
          block: c,
          linkComponent: e.linkComponent,
          context: e.context || e.builderContext,
          registeredComponents: e.registeredComponents || ((b = e.componentsContext) == null ? void 0 : b.registeredComponents)
        }, null, 8, ["block", "linkComponent", "context", "registeredComponents"]);
      }), 128)) : C("", !0)
    ]),
    _: 3
  }, 8, ["blocks", "parent", "path", "styleProp", "BlocksWrapperProps", "classNameProp", "BlocksWrapper"]);
}
const q = /* @__PURE__ */ v(ko, [["render", Co]]), To = y({
  name: "dynamic-div",
  props: []
});
function wo(e, t, n, o, r, i) {
  return d(), h("div", null, [
    N(e.$slots, "default")
  ]);
}
const te = /* @__PURE__ */ v(To, [["render", wo]]), Io = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: te
}, Symbol.toStringTag, { value: "Module" })), ue = y({
  render() {
    return ze("style", {
      innerHTML: this.styles,
      "data-id": this.id,
      nonce: this.nonce
    });
  },
  name: "inlined-styles",
  props: ["styles", "id", "nonce"]
}), Tt = {
  xsmall: {
    min: 0,
    default: 160,
    max: 320
  },
  small: {
    min: 321,
    default: 321,
    max: 640
  },
  medium: {
    min: 641,
    default: 642,
    max: 991
  },
  large: {
    min: 990,
    default: 991,
    max: 1200
  }
}, Ps = (e, t = Tt) => `@media (max-width: ${t[e].max}px)`, $o = (e) => {
  const t = Ce(Tt);
  if (!e)
    return t;
  const {
    xsmall: n,
    small: o,
    medium: r
  } = e;
  if (n) {
    const a = Math.floor(n / 2);
    t.xsmall = {
      max: n,
      min: a,
      default: a + 1
    };
  }
  if (!o || !r)
    return t;
  const i = n ? t.xsmall.max + 1 : Math.floor(o / 2);
  t.small = {
    max: o,
    min: i,
    default: i + 1
  };
  const s = t.small.max + 1;
  t.medium = {
    max: r,
    min: s,
    default: s + 1
  };
  const l = t.medium.max + 1;
  return t.large = {
    max: 2e3,
    // TODO: decide upper limit
    min: l,
    default: l + 1
  }, t;
}, Ro = (e) => `builder-columns ${e}-breakpoints`, Eo = y({
  name: "builder-columns",
  components: {
    InlinedStyles: ue,
    DynamicRenderer: ke,
    Blocks: q,
    DynamicDiv: te
  },
  props: [
    "space",
    "columns",
    "stackColumnsAt",
    "builderLinkComponent",
    "reverseColumnsWhenStacked",
    "builderContext",
    "builderBlock",
    "builderComponents"
  ],
  data() {
    return { TARGET: R, getColumnsClass: Ro };
  },
  computed: {
    gutterSize() {
      return typeof this.space == "number" ? this.space || 0 : 20;
    },
    cols() {
      return this.columns || [];
    },
    stackAt() {
      return this.stackColumnsAt || "tablet";
    },
    flexDir() {
      return this.stackColumnsAt === "never" ? "row" : this.reverseColumnsWhenStacked ? "column-reverse" : "column";
    }
  },
  methods: {
    getTagName(e) {
      return e.link ? this.builderLinkComponent || "a" : "div";
    },
    getWidth(e) {
      var t;
      return ((t = this.cols[e]) == null ? void 0 : t.width) || 100 / this.cols.length;
    },
    getColumnCssWidth(e) {
      const t = this.getWidth(e), n = this.gutterSize * (this.cols.length - 1) * (t / 100);
      return `calc(${t}% - ${n}px)`;
    },
    getTabletStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "tablet" ? e : t;
    },
    getMobileStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "never" ? t : e;
    },
    columnsCssVars() {
      return {
        "--flex-dir": this.flexDir,
        "--flex-dir-tablet": this.getTabletStyle({
          stackedStyle: this.flexDir,
          desktopStyle: "row"
        })
      };
    },
    columnCssVars(e) {
      const t = e === 0 ? 0 : this.gutterSize, n = this.getColumnCssWidth(e), o = `${t}px`, r = "100%", i = 0;
      return {
        ...{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        },
        width: n,
        ["margin-left"]: o,
        "--column-width-mobile": this.getMobileStyle({
          stackedStyle: r,
          desktopStyle: n
        }),
        "--column-margin-left-mobile": this.getMobileStyle({
          stackedStyle: i,
          desktopStyle: o
        }),
        "--column-width-tablet": this.getTabletStyle({
          stackedStyle: r,
          desktopStyle: n
        }),
        "--column-margin-left-tablet": this.getTabletStyle({
          stackedStyle: i,
          desktopStyle: o
        })
      };
    },
    getWidthForBreakpointSize(e) {
      var n, o;
      return $o(
        ((o = (n = this.builderContext.content) == null ? void 0 : n.meta) == null ? void 0 : o.breakpoints) || {}
      )[e].max;
    },
    columnsStyles() {
      const e = `.${this.builderBlock.id}-breakpoints > .builder-column`;
      return `
        @media (max-width: ${this.getWidthForBreakpointSize("medium")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          ${e} {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${this.getWidthForBreakpointSize("small")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          ${e} {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
    },
    getAttributes(e, t) {
      return {
        ...e.link ? {
          href: e.link
        } : {},
        [j()]: "builder-column",
        style: St(this.columnCssVars(t))
      };
    }
  }
});
function Ao(e, t, n, o, r, i) {
  var u;
  const s = k("InlinedStyles"), l = k("Blocks"), a = k("DynamicRenderer");
  return d(), h("div", $({
    class: e.getColumnsClass((u = e.builderBlock) == null ? void 0 : u.id) + " div-1be3j8m9ewb",
    style: e.columnsCssVars()
  }, {}), [
    e.TARGET !== "reactNative" ? (d(), S(s, {
      key: 0,
      id: "builderio-columns",
      styles: e.columnsStyles(),
      nonce: e.builderContext.nonce
    }, null, 8, ["styles", "nonce"])) : C("", !0),
    (d(!0), h(I, null, F(e.columns, (p, f) => (d(), S(a, {
      key: f,
      TagName: e.getTagName(p),
      actionAttributes: {},
      attributes: e.getAttributes(p, f)
    }, {
      default: O(() => [
        E(l, {
          path: `columns.${f}.blocks`,
          parent: e.builderBlock.id,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent,
          blocks: p.blocks,
          styleProp: {
            flexGrow: "1"
          }
        }, null, 8, ["path", "parent", "context", "registeredComponents", "linkComponent", "blocks"])
      ]),
      _: 2
    }, 1032, ["TagName", "attributes"]))), 128))
  ], 16);
}
const Po = /* @__PURE__ */ v(Eo, [["render", Ao], ["__scopeId", "data-v-ab15749a"]]), Bo = y({
  name: "builder-fragment-component",
  props: []
});
function Vo(e, t, n, o, r, i) {
  return d(), h("span", null, [
    N(e.$slots, "default")
  ]);
}
const No = /* @__PURE__ */ v(Bo, [["render", Vo]]);
function Me(e) {
  return e.replace(/http(s)?:/, "");
}
function xo(e = "", t, n) {
  const o = new RegExp("([?&])" + t + "=.*?(&|$)", "i"), r = e.indexOf("?") !== -1 ? "&" : "?";
  return e.match(o) ? e.replace(o, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + r + t + "=" + encodeURIComponent(n);
}
function Wo(e, t) {
  if (!e || !(e != null && e.match(/cdn\.shopify\.com/)) || !t)
    return e;
  if (t === "master")
    return Me(e);
  const n = e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (n) {
    const o = e.split(n[0]), r = n[3], i = t.match("x") ? t : `${t}x`;
    return Me(`${o[0]}_${i}${r}`);
  }
  return null;
}
function oe(e) {
  if (!e)
    return e;
  const t = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (e.match(/builder\.io/)) {
    let n = e;
    const o = Number(e.split("?width=")[1]);
    return isNaN(o) || (n = `${n} ${o}w`), t.filter((r) => r !== o).map((r) => `${xo(e, "width", r)} ${r}w`).concat([n]).join(", ");
  }
  return e.match(/cdn\.shopify\.com/) ? t.map((n) => [Wo(e, `${n}x${n}`), n]).filter(([n]) => !!n).map(([n, o]) => `${n} ${o}w`).concat([e]).join(", ") : e;
}
const Do = y({
  name: "builder-image",
  props: [
    "lazy",
    "image",
    "src",
    "srcset",
    "noWebp",
    "aspectRatio",
    "highPriority",
    "altText",
    "title",
    "backgroundPosition",
    "backgroundSize",
    "className",
    "sizes",
    "builderBlock",
    "fitContent"
  ],
  computed: {
    srcSetToUse() {
      var n;
      const t = this.image || this.src;
      if (!t || // We can auto add srcset for cdn.builder.io and shopify
      // images, otherwise you can supply this prop manually
      !(typeof t == "string" && (t.match(/builder\.io/) || t.match(/cdn\.shopify\.com/))))
        return this.srcset;
      if (!this.noWebp) {
        if (this.srcset && ((n = this.image) != null && n.includes("builder.io/api/v1/image"))) {
          if (!this.srcset.includes(this.image.split("?")[0]))
            return console.debug("Removed given srcset"), oe(t);
        } else if (this.image && !this.srcset)
          return oe(t);
        return oe(t);
      }
    },
    webpSrcSet() {
      var e;
      return (e = this.srcSetToUse) != null && e.match(/builder\.io/) && !this.noWebp ? this.srcSetToUse.replace(/\?/g, "?format=webp&") : "";
    },
    aspectRatioCss() {
      const e = {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "0px",
        top: "0px"
      };
      return this.aspectRatio ? e : void 0;
    }
  }
}), Oo = ["srcset"], Uo = ["loading", "fetchpriority", "alt", "title", "role", "src", "srcset", "sizes"], Lo = {
  key: 2,
  class: "div-t43jfuqn6g-2"
};
function Fo(e, t, n, o, r, i) {
  var s, l, a, u, p, f;
  return d(), h(I, null, [
    z("picture", null, [
      e.webpSrcSet ? (d(), h("source", {
        key: 0,
        type: "image/webp",
        srcset: e.webpSrcSet
      }, null, 8, Oo)) : C("", !0),
      z("img", {
        loading: e.highPriority ? "eager" : "lazy",
        fetchpriority: e.highPriority ? "high" : "auto",
        alt: e.altText,
        title: e.title,
        role: e.altText ? void 0 : "presentation",
        style: M({
          objectPosition: e.backgroundPosition || "center",
          objectFit: e.backgroundSize || "cover",
          ...e.aspectRatioCss
        }),
        class: Z(
          "builder-image" + (e.className ? " " + e.className : "") + " img-t43jfuqn6g"
        ),
        src: e.image,
        srcset: e.srcSetToUse,
        sizes: e.sizes
      }, null, 14, Uo)
    ]),
    e.aspectRatio && !((l = (s = e.builderBlock) == null ? void 0 : s.children) != null && l.length && e.fitContent) ? (d(), h("div", {
      key: 0,
      class: "builder-image-sizer div-t43jfuqn6g",
      style: M({
        paddingTop: e.aspectRatio * 100 + "%"
      })
    }, null, 4)) : C("", !0),
    (u = (a = e.builderBlock) == null ? void 0 : a.children) != null && u.length && e.fitContent ? N(e.$slots, "default", { key: 1 }, void 0, !0) : C("", !0),
    !e.fitContent && ((f = (p = e.builderBlock) == null ? void 0 : p.children) != null && f.length) ? (d(), h("div", Lo, [
      N(e.$slots, "default", {}, void 0, !0)
    ])) : C("", !0)
  ], 64);
}
const Ho = /* @__PURE__ */ v(Do, [["render", Fo], ["__scopeId", "data-v-741b9bbc"]]), Mo = y({
  name: "builder-section-component",
  props: ["attributes", "maxWidth"],
  data() {
    return { filterAttrs: x };
  }
});
function jo(e, t, n, o, r, i) {
  return d(), h("section", $({
    style: {
      width: "100%",
      alignSelf: "stretch",
      flexGrow: 1,
      boxSizing: "border-box",
      maxWidth: e.maxWidth || 1200,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, e.filterAttrs(e.attributes, "v-on:", !1), L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    N(e.$slots, "default")
  ], 16);
}
const Ko = /* @__PURE__ */ v(Mo, [["render", jo]]);
function qo(e, t, n, o) {
  function r(u) {
    return typeof u == "string";
  }
  function i(u) {
    return typeof u == "number";
  }
  function s(u, p) {
    return (() => {
      const c = p.property, m = p.operator;
      let b = p.value;
      if (p && p.property === "urlPath" && p.value && typeof p.value == "string" && p.value !== "/" && p.value.endsWith("/") && (b = p.value.slice(0, -1)), !(c && m))
        return !0;
      if (Array.isArray(b))
        return m === "isNot" ? b.every((P) => s(u, {
          property: c,
          operator: m,
          value: P
        })) : !!b.find((P) => s(u, {
          property: c,
          operator: m,
          value: P
        }));
      const g = u[c];
      if (Array.isArray(g))
        return g.includes(b);
      switch (m) {
        case "is":
          return g === b;
        case "isNot":
          return g !== b;
        case "contains":
          return (r(g) || Array.isArray(g)) && g.includes(String(b));
        case "startsWith":
          return r(g) && g.startsWith(String(b));
        case "endsWith":
          return r(g) && g.endsWith(String(b));
        case "greaterThan":
          return i(g) && i(b) && g > b;
        case "lessThan":
          return i(g) && i(b) && g < b;
        case "greaterThanOrEqualTo":
          return i(g) && i(b) && g >= b;
        case "lessThanOrEqualTo":
          return i(g) && i(b) && g <= b;
        default:
          return !1;
      }
    })();
  }
  const l = {
    query: t,
    startDate: n,
    endDate: o
  }, a = e.date && new Date(e.date) || /* @__PURE__ */ new Date();
  return l.startDate && new Date(l.startDate) > a || l.endDate && new Date(l.endDate) < a ? !1 : !l.query || !l.query.length ? !0 : l.query.every((u) => s(e, u));
}
const zo = `function getPersonalizedVariant(variants, blockId, isHydrationTarget, locale) {
  if (!navigator.cookieEnabled) {
    return;
  }
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const attributes = JSON.parse(getCookie('builder.userAttributes') || '{}');
  if (locale) {
    attributes.locale = locale;
  }
  const winningVariantIndex = variants?.findIndex(function (variant) {
    return window.filterWithCustomTargeting(attributes, variant.query, variant.startDate, variant.endDate);
  });
  const parentDiv = document.currentScript?.parentElement;
  const variantId = parentDiv?.getAttribute('data-variant-id');
  const isDefaultVariant = variantId === \`\${blockId}-default\`;
  const isWinningVariant = winningVariantIndex !== -1 && variantId === \`\${blockId}-\${winningVariantIndex}\` || winningVariantIndex === -1 && isDefaultVariant;
  if (isWinningVariant && !isDefaultVariant) {
    parentDiv?.removeAttribute('hidden');
    parentDiv?.removeAttribute('aria-hidden');
  } else if (!isWinningVariant && isDefaultVariant) {
    parentDiv?.setAttribute('hidden', 'true');
    parentDiv?.setAttribute('aria-hidden', 'true');
  }
  if (isHydrationTarget) {
    if (!isWinningVariant) {
      const itsStyleEl = parentDiv?.previousElementSibling;
      if (itsStyleEl) {
        itsStyleEl.remove();
      }
      parentDiv?.remove();
    }
    const thisScript = document.currentScript;
    if (thisScript) {
      thisScript.remove();
    }
  }
}`, Go = `function filterWithCustomTargeting(userAttributes, query, startDate, endDate) {
  function isString(val) {
    return typeof val === 'string';
  }
  function isNumber(val) {
    return typeof val === 'number';
  }
  function objectMatchesQuery(userattr, query) {
    const result = (() => {
      const property = query.property;
      const operator = query.operator;
      let testValue = query.value;
      if (query && query.property === 'urlPath' && query.value && typeof query.value === 'string' && query.value !== '/' && query.value.endsWith('/')) {
        testValue = query.value.slice(0, -1);
      }
      if (!(property && operator)) {
        return true;
      }
      if (Array.isArray(testValue)) {
        if (operator === 'isNot') {
          return testValue.every(val => objectMatchesQuery(userattr, {
            property,
            operator,
            value: val
          }));
        }
        return !!testValue.find(val => objectMatchesQuery(userattr, {
          property,
          operator,
          value: val
        }));
      }
      const value = userattr[property];
      if (Array.isArray(value)) {
        return value.includes(testValue);
      }
      switch (operator) {
        case 'is':
          return value === testValue;
        case 'isNot':
          return value !== testValue;
        case 'contains':
          return (isString(value) || Array.isArray(value)) && value.includes(String(testValue));
        case 'startsWith':
          return isString(value) && value.startsWith(String(testValue));
        case 'endsWith':
          return isString(value) && value.endsWith(String(testValue));
        case 'greaterThan':
          return isNumber(value) && isNumber(testValue) && value > testValue;
        case 'lessThan':
          return isNumber(value) && isNumber(testValue) && value < testValue;
        case 'greaterThanOrEqualTo':
          return isNumber(value) && isNumber(testValue) && value >= testValue;
        case 'lessThanOrEqualTo':
          return isNumber(value) && isNumber(testValue) && value <= testValue;
        default:
          return false;
      }
    })();
    return result;
  }
  const item = {
    query,
    startDate,
    endDate
  };
  const now = userAttributes.date && new Date(userAttributes.date) || new Date();
  if (item.startDate && new Date(item.startDate) > now) {
    return false;
  } else if (item.endDate && new Date(item.endDate) < now) {
    return false;
  }
  if (!item.query || !item.query.length) {
    return true;
  }
  return item.query.every(filter => {
    return objectMatchesQuery(userAttributes, filter);
  });
}`, Jo = `function updateVisibilityStylesScript(variants, blockId, isHydrationTarget, locale) {
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const visibilityStylesEl = document.currentScript?.previousElementSibling;
  if (!visibilityStylesEl) {
    return;
  }
  if (isHydrationTarget) {
    visibilityStylesEl.remove();
    const currentScript = document.currentScript;
    if (currentScript) {
      currentScript.remove();
    }
  } else {
    const attributes = JSON.parse(getCookie('builder.userAttributes') || '{}');
    if (locale) {
      attributes.locale = locale;
    }
    const winningVariantIndex = variants?.findIndex(function (variant) {
      return window.filterWithCustomTargeting(attributes, variant.query, variant.startDate, variant.endDate);
    });
    if (winningVariantIndex !== -1) {
      let newStyleStr = variants?.map((_, index) => {
        if (index === winningVariantIndex) return '';
        return \`div[data-variant-id="\${blockId}-\${index}"] { display: none !important; } \`;
      }).join('') || '';
      newStyleStr += \`div[data-variant-id="\${blockId}-default"] { display: none !important; } \`;
      visibilityStylesEl.innerHTML = newStyleStr;
    }
  }
}`, re = "default", Qo = "filterWithCustomTargeting", wt = "builderIoPersonalization", It = "updateVisibilityStylesScript", $t = ["react", "vue", "svelte", "qwik"], Rt = ["vue", "svelte", "qwik"];
function Yo(e, t) {
  return !(e && e.length > 0) || !t ? !1 : Rt.includes(R) ? !0 : !T();
}
function Xo({
  variants: e,
  previewingIndex: t,
  isHydrated: n,
  filteredVariants: o,
  fallbackBlocks: r
}) {
  const i = {
    blocks: r ?? [],
    path: "this.children",
    index: re
  };
  if (n && A()) {
    if (typeof t == "number" && t < ((e == null ? void 0 : e.length) ?? 0)) {
      const s = e == null ? void 0 : e[t];
      if (s)
        return {
          blocks: s.blocks,
          path: `variants.${t}.blocks`,
          index: t
        };
    }
    return i;
  }
  if (T()) {
    const s = o == null ? void 0 : o[0];
    if (s && e) {
      const l = e.indexOf(s);
      if (l !== -1)
        return {
          blocks: s.blocks,
          path: `variants.${l}.blocks`,
          index: l
        };
    }
  }
  return i;
}
const _o = () => `
  window.${Qo} = ${Go}
  window.${wt} = ${zo}
  window.${It} = ${Jo}
  `, Et = R === "react", Zo = (e, t, n) => `window.${wt}(${JSON.stringify(e)}, "${t}", ${Et}${n ? `, "${n}"` : ""})`, er = (e, t, n) => `window.${It}(${JSON.stringify(e)}, "${t}", ${Et}${n ? `, "${n}"` : ""})`, pe = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Accordion item title",
  responsiveStyles: {
    large: {
      marginTop: "10px",
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
      paddingBottom: "10px"
    }
  },
  children: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "left",
        display: "flex",
        flexDirection: "column"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "I am an accordion title. Click me!"
      }
    }
  }]
}, me = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Accordion item detail",
  responsiveStyles: {
    large: {
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
      marginTop: "10px",
      paddingBottom: "10px"
    }
  },
  children: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        paddingTop: "50px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "50px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "I am an accordion detail, hello!"
      }
    }
  }]
}, tr = {
  name: "Builder:Accordion",
  canHaveChildren: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Ffab6c1fd3fe542408cbdec078bca7f35",
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  },
  inputs: [{
    name: "items",
    type: "list",
    broadcast: !0,
    subFields: [{
      name: "title",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [pe]
    }, {
      name: "detail",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [me]
    }],
    defaultValue: [{
      title: [pe],
      detail: [me]
    }, {
      title: [pe],
      detail: [me]
    }],
    showIf: (e) => !e.get("useChildrenForItems")
  }, {
    name: "oneAtATime",
    helperText: "Only allow opening one at a time (collapse all others when new item openned)",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "grid",
    helperText: "Display as a grid",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "gridRowWidth",
    helperText: "Display as a grid",
    type: "string",
    showIf: (e) => e.get("grid"),
    defaultValue: "25%"
  }, {
    name: "useChildrenForItems",
    type: "boolean",
    helperText: "Use child elements for each slide, instead of the array. Useful for dynamically repeating items",
    advanced: !0,
    defaultValue: !1,
    onChange: (e) => {
      e.get("useChildrenForItems") === !0 && e.set("items", []);
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, nr = (e) => e.toString(), or = y({
  name: "builder-accordion",
  components: { Blocks: q },
  props: [
    "grid",
    "oneAtATime",
    "items",
    "gridRowWidth",
    "builderBlock",
    "builderContext",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    return { open: [], convertOrderNumberToString: nr };
  },
  computed: {
    onlyOneAtATime() {
      return !!(this.grid || this.oneAtATime);
    },
    accordionStyles() {
      return {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "column",
        ...this.grid && {
          flexDirection: "row",
          alignItems: "flex-start",
          flexWrap: "wrap"
        }
      };
    },
    accordionTitleStyles() {
      const t = {
        ...{
          display: "flex",
          flexDirection: "column"
        },
        alignItems: "stretch",
        cursor: "pointer"
      };
      return Object.fromEntries(
        Object.entries(t).filter(([n, o]) => o !== void 0)
      );
    },
    openGridItemOrder() {
      let e = null;
      if (this.grid && this.open.length && document) {
        const n = this.open[0];
        let r = document.querySelector(
          `.builder-accordion-title[data-index="${n}"]`
        );
        if (e = n, r) {
          let i = r.getBoundingClientRect();
          for (; r = r && r.nextElementSibling; )
            if (r) {
              if (r.classList.contains("builder-accordion-detail"))
                continue;
              const s = r.getBoundingClientRect();
              if (s.left > i.left) {
                const l = parseInt(
                  r.getAttribute("data-index") || "",
                  10
                );
                isNaN(l) || (i = s, e = l);
              } else
                break;
            }
        }
      }
      return typeof e == "number" && (e = e + 1), e;
    },
    accordionDetailStyles() {
      const e = {
        order: typeof this.openGridItemOrder == "number" ? this.openGridItemOrder : void 0,
        ...this.grid && {
          width: "100%"
        }
      };
      return Object.fromEntries(
        Object.entries(e).filter(([t, n]) => n !== void 0)
      );
    }
  },
  methods: {
    getAccordionTitleClassName(e) {
      return `builder-accordion-title builder-accordion-title-${this.open.includes(e) ? "open" : "closed"}`;
    },
    getAccordionDetailClassName(e) {
      return `builder-accordion-detail builder-accordion-detail-${this.open.includes(e) ? "open" : "closed"}`;
    },
    onClick(e) {
      this.open.includes(e) ? this.open = this.onlyOneAtATime ? [] : this.open.filter((t) => t !== e) : this.open = this.onlyOneAtATime ? [e] : this.open.concat(e);
    }
  }
}), rr = ["data-index", "onClick"];
function ir(e, t, n, o, r, i) {
  const s = k("Blocks");
  return d(), h("div", {
    class: "builder-accordion",
    style: M(e.accordionStyles)
  }, [
    (d(!0), h(I, null, F(e.items, (l, a) => (d(), h(I, { key: a }, [
      z("div", {
        class: Z(e.getAccordionTitleClassName(a)),
        style: M({
          ...e.accordionTitleStyles,
          ...e.grid && {
            width: e.gridRowWidth,
            order: e.openGridItemOrder !== null ? e.convertOrderNumberToString(a) : e.convertOrderNumberToString(a + 1)
          }
        }),
        "data-index": a,
        onClick: async (u) => e.onClick(a)
      }, [
        E(s, {
          blocks: l.title,
          path: `items.${a}.title`,
          parent: e.builderBlock.id,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["blocks", "path", "parent", "context", "registeredComponents", "linkComponent"])
      ], 14, rr),
      e.open.includes(a) ? (d(), h("div", {
        key: 0,
        class: Z(e.getAccordionDetailClassName(a)),
        style: M(e.accordionDetailStyles)
      }, [
        E(s, {
          blocks: l.detail,
          path: `items.${a}.detail`,
          parent: e.builderBlock.id,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["blocks", "path", "parent", "context", "registeredComponents", "linkComponent"])
      ], 6)) : C("", !0)
    ], 64))), 128))
  ], 4);
}
const sr = /* @__PURE__ */ v(or, [["render", ir]]), ar = {
  name: "Core:Button",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    // TODO: make min width more intuitive and set one
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#000000",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me!",
    bubble: !0
  }, {
    name: "link",
    type: "url",
    bubble: !0
  }, {
    name: "openLinkInNewTab",
    type: "boolean",
    defaultValue: !1,
    friendlyName: "Open link in new tab"
  }],
  static: !0,
  noWrap: !0,
  shouldReceiveBuilderProps: {
    builderLinkComponent: !0
  }
}, lr = {
  // TODO: ways to statically preprocess JSON for references, functions, etc
  name: "Columns",
  isRSC: !0,
  inputs: [{
    name: "columns",
    type: "array",
    broadcast: !0,
    subFields: [{
      name: "blocks",
      type: "array",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0,
      helperText: "Width %, e.g. set to 50 to fill half of the space"
    }, {
      name: "link",
      type: "url",
      helperText: "Optionally set a url that clicking this column will link to"
    }],
    defaultValue: [{
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }],
    onChange: (e) => {
      function t() {
        n.forEach((o) => {
          o.delete("width");
        });
      }
      const n = e.get("columns");
      Array.isArray(n) && n.find((r) => r.get("width")) && (n.find((i) => !i.get("width")) || n.reduce((l, a) => l + a.get("width"), 0) !== 100) && t();
    }
  }, {
    name: "space",
    type: "number",
    defaultValue: 20,
    helperText: "Size of gap between columns",
    advanced: !0
  }, {
    name: "stackColumnsAt",
    type: "string",
    defaultValue: "tablet",
    helperText: "Convert horizontal columns to vertical at what device size",
    enum: ["tablet", "mobile", "never"],
    advanced: !0
  }, {
    name: "reverseColumnsWhenStacked",
    type: "boolean",
    defaultValue: !1,
    helperText: "When stacking columns for mobile devices, reverse the ordering",
    advanced: !0
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, cr = {
  name: "Fragment",
  static: !0,
  hidden: !0,
  canHaveChildren: !0,
  noWrap: !0
}, Pe = ["jpeg", "jpg", "png", "svg", "webp", "gif", "jfif", "pjpeg", "pjp", "apng", "avif", "tif", "tiff", "heif", "bmp", "eps", "raw", "cr2", "nef", "orf", "sr2", "psd", "heic", "dib", "ai"], dr = ["mp4", "webm", "mkv", "flv", "vob", "ogv", "ogg", "drc", "gif", "gifv", "mng", "avi", "mov", "qt", "mts", "m2ts", "ts", "wmv", "yuv", "rm", "rmvb", "viv", "asf", "amv", "m4p", "mpeg", "mpe", "m2v", "m4v", "svi", "3gp", "3g2", "mxf", "roq", "nsv", "f4v", "f4p", "f4a", "f4b"], ur = {
  name: "Image",
  static: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    position: "relative",
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [{
    name: "image",
    type: "file",
    bubble: !0,
    allowedFileTypes: Pe,
    required: !0,
    defaultValue: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",
    onChange: (e) => {
      e.delete("srcset"), e.delete("noWebp");
      function n(s, l = 6e4) {
        return new Promise((a, u) => {
          const p = document.createElement("img");
          let f = !1;
          p.onload = () => {
            f = !0, a(p);
          }, p.addEventListener("error", (c) => {
            console.warn("Image load failed", c.error), u(c.error);
          }), p.src = s, setTimeout(() => {
            f || u(new Error("Image load timed out"));
          }, l);
        });
      }
      function o(s) {
        return Math.round(s * 1e3) / 1e3;
      }
      const r = e.get("image"), i = e.get("aspectRatio");
      if (fetch(r).then((s) => s.blob()).then((s) => {
        s.type.includes("svg") && e.set("noWebp", !0);
      }), r && (!i || i === 0.7041))
        return n(r).then((s) => {
          const l = e.get("aspectRatio");
          e.get("image") === r && (!l || l === 0.7041) && s.width && s.height && (e.set("aspectRatio", o(s.height / s.width)), e.set("height", s.height), e.set("width", s.width));
        });
    }
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    enum: [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "title",
    type: "string",
    helperText: "Text to display when hovering over the asset"
  }, {
    name: "height",
    type: "number",
    hideFromUI: !0
  }, {
    name: "width",
    type: "number",
    hideFromUI: !0
  }, {
    name: "sizes",
    type: "string",
    hideFromUI: !0
  }, {
    name: "srcset",
    type: "string",
    hideFromUI: !0
  }, {
    name: "lazy",
    type: "boolean",
    defaultValue: !0,
    hideFromUI: !0
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
    defaultValue: !0
  }, {
    name: "highPriority",
    type: "boolean",
    advanced: !0,
    helperText: "Mark this image as high priority compared to other images on the page. This prevents lazy loading of the image and tells the browser to load this image before others on the page."
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: 0.7041
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0
  }
}, pr = {
  name: "PersonalizationContainer",
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0
  },
  noWrap: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F37229ed30d8c41dfb10b8cca1992053a",
  canHaveChildren: !0,
  inputs: [{
    name: "variants",
    defaultValue: [],
    behavior: "personalizationVariantList",
    type: "list",
    subFields: [{
      name: "name",
      type: "text"
    }, {
      name: "query",
      friendlyName: "Targeting rules",
      type: "BuilderQuery",
      defaultValue: []
    }, {
      name: "startDate",
      type: "date"
    }, {
      name: "endDate",
      type: "date"
    }, {
      name: "blocks",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: []
    }]
  }]
}, Be = y({
  render() {
    return ze("script", {
      innerHTML: this.scriptStr,
      "data-id": this.id,
      nonce: this.nonce
    });
  },
  name: "inlined-script",
  props: ["scriptStr", "id", "nonce"]
}), mr = y({
  name: "builder-personalization-container",
  components: {
    Blocks: q,
    InlinedStyles: ue,
    InlinedScript: Be
  },
  props: [
    "builderContext",
    "variants",
    "builderBlock",
    "attributes",
    "previewingIndex",
    "builderComponents"
  ],
  data() {
    var e, t, n, o, r, i, s;
    return {
      userAttributes: le.getUserAttributes(),
      scriptStr: Zo(
        this.variants,
        ((e = this.builderBlock) == null ? void 0 : e.id) || "none",
        (n = (t = this.builderContext) == null ? void 0 : t.rootState) == null ? void 0 : n.locale
      ),
      updateVisibilityStylesScript: er(
        this.variants,
        ((o = this.builderBlock) == null ? void 0 : o.id) || "none",
        (i = (r = this.builderContext) == null ? void 0 : r.rootState) == null ? void 0 : i.locale
      ),
      unsubscribers: [],
      shouldRenderVariants: Yo(
        this.variants,
        G((s = this.builderContext) == null ? void 0 : s.canTrack)
      ),
      shouldResetVariants: !1,
      TARGET: R,
      DEFAULT_INDEX: re,
      SDKS_REQUIRING_RESET_APPROACH: Rt
    };
  },
  mounted() {
    var t;
    this.shouldResetVariants = !0;
    const e = le.subscribeOnUserAttributesChange(
      (n) => {
        this.userAttributes = n;
      },
      {
        fireImmediately: R === "qwik"
      }
    );
    if (!(A() || Te())) {
      const n = this.filteredVariants[0];
      this.$refs.rootRef && (this.$refs.rootRef.dispatchEvent(
        new CustomEvent("builder.variantLoaded", {
          detail: {
            variant: n || re,
            content: (t = this.builderContext) == null ? void 0 : t.content
          },
          bubbles: !0
        })
      ), new IntersectionObserver((r) => {
        r.forEach((i) => {
          var s;
          i.isIntersecting && this.$refs.rootRef && this.$refs.rootRef.dispatchEvent(
            new CustomEvent("builder.variantDisplayed", {
              detail: {
                variant: n || re,
                content: (s = this.builderContext) == null ? void 0 : s.content
              },
              bubbles: !0
            })
          );
        });
      }).observe(this.$refs.rootRef));
    }
    this.unsubscribers.push(e);
  },
  unmounted() {
    this.unsubscribers.forEach((e) => e());
  },
  computed: {
    attrs() {
      return {
        ...x(this.attributes, "v-on:", !1),
        ...x(this.attributes, "v-on:", !0),
        [j()]: `builder-personalization-container ${this.attributes[j()] || ""}`
      };
    },
    filteredVariants() {
      return (this.variants || []).filter((e) => {
        var t, n, o, r;
        return qo(
          {
            ...(n = (t = this.builderContext) == null ? void 0 : t.rootState) != null && n.locale ? {
              locale: (r = (o = this.builderContext) == null ? void 0 : o.rootState) == null ? void 0 : r.locale
            } : {},
            ...this.userAttributes
          },
          e.query,
          e.startDate,
          e.endDate
        );
      });
    },
    blocksToRender() {
      var e;
      return Xo({
        variants: this.variants,
        fallbackBlocks: (e = this.builderBlock) == null ? void 0 : e.children,
        isHydrated: this.shouldResetVariants,
        filteredVariants: this.filteredVariants,
        previewingIndex: this.previewingIndex
      });
    },
    hideVariantsStyleString() {
      return (this.variants || []).map(
        (e, t) => {
          var n;
          return `div[data-variant-id="${(n = this.builderBlock) == null ? void 0 : n.id}-${t}"] { display: none !important; } `;
        }
      ).join("");
    }
  }
});
function hr(e, t, n, o, r, i) {
  var u, p, f, c, m, b, g, P, U, V;
  const s = k("Blocks"), l = k("InlinedStyles"), a = k("InlinedScript");
  return d(), h("div", $({ ref: "rootRef" }, e.attrs), [
    e.shouldResetVariants && e.SDKS_REQUIRING_RESET_APPROACH.includes(e.TARGET) ? (d(), S(s, {
      key: 0,
      blocks: e.blocksToRender.blocks,
      parent: (u = e.builderBlock) == null ? void 0 : u.id,
      path: e.blocksToRender.path,
      context: e.builderContext,
      registeredComponents: e.builderComponents,
      BlocksWrapperProps: {
        ...(p = e.builderContext) == null ? void 0 : p.BlocksWrapperProps,
        "data-variant-id": `${(f = e.builderBlock) == null ? void 0 : f.id}-${e.blocksToRender.index}`
      }
    }, null, 8, ["blocks", "parent", "path", "context", "registeredComponents", "BlocksWrapperProps"])) : C("", !0),
    !e.shouldResetVariants && e.SDKS_REQUIRING_RESET_APPROACH.includes(e.TARGET) || !e.SDKS_REQUIRING_RESET_APPROACH.includes(e.TARGET) ? (d(), h(I, { key: 1 }, [
      e.shouldRenderVariants ? (d(), h(I, { key: 0 }, [
        E(l, {
          nonce: ((c = e.builderContext) == null ? void 0 : c.nonce) || "",
          styles: e.hideVariantsStyleString,
          id: `variants-styles-${(m = e.builderBlock) == null ? void 0 : m.id}`
        }, null, 8, ["nonce", "styles", "id"]),
        E(a, {
          nonce: ((b = e.builderContext) == null ? void 0 : b.nonce) || "",
          scriptStr: e.updateVisibilityStylesScript,
          id: `variants-visibility-script-${(g = e.builderBlock) == null ? void 0 : g.id}`
        }, null, 8, ["nonce", "scriptStr", "id"]),
        (d(!0), h(I, null, F(e.variants, (w, W) => {
          var J, Q, D, H;
          return d(), S(s, {
            key: `${(J = e.builderBlock) == null ? void 0 : J.id}-${W}`,
            BlocksWrapperProps: {
              ...(Q = e.builderContext) == null ? void 0 : Q.BlocksWrapperProps,
              "aria-hidden": !0,
              hidden: !0,
              "data-variant-id": `${(D = e.builderBlock) == null ? void 0 : D.id}-${W}`
            },
            blocks: w.blocks,
            parent: (H = e.builderBlock) == null ? void 0 : H.id,
            path: `component.options.variants.${W}.blocks`,
            context: e.builderContext,
            registeredComponents: e.builderComponents
          }, {
            default: O(() => {
              var Ve, Ne;
              return [
                E(a, {
                  nonce: ((Ve = e.builderContext) == null ? void 0 : Ve.nonce) || "",
                  scriptStr: e.scriptStr,
                  id: `variants-script-${(Ne = e.builderBlock) == null ? void 0 : Ne.id}-${W}`
                }, null, 8, ["nonce", "scriptStr", "id"])
              ];
            }),
            _: 2
          }, 1032, ["BlocksWrapperProps", "blocks", "parent", "path", "context", "registeredComponents"]);
        }), 128))
      ], 64)) : C("", !0),
      E(s, {
        blocks: e.blocksToRender.blocks,
        parent: (P = e.builderBlock) == null ? void 0 : P.id,
        path: e.blocksToRender.path,
        context: e.builderContext,
        registeredComponents: e.builderComponents,
        BlocksWrapperProps: {
          ...(U = e.builderContext) == null ? void 0 : U.BlocksWrapperProps,
          "data-variant-id": `${(V = e.builderBlock) == null ? void 0 : V.id}-${e.blocksToRender.index}`
        }
      }, {
        default: O(() => {
          var w, W;
          return [
            e.shouldRenderVariants ? (d(), S(a, {
              key: 0,
              nonce: ((w = e.builderContext) == null ? void 0 : w.nonce) || "",
              scriptStr: e.scriptStr,
              id: `variants-script-${(W = e.builderBlock) == null ? void 0 : W.id}-${e.DEFAULT_INDEX}`
            }, null, 8, ["nonce", "scriptStr", "id"])) : C("", !0)
          ];
        }),
        _: 1
      }, 8, ["blocks", "parent", "path", "context", "registeredComponents", "BlocksWrapperProps"])
    ], 64)) : C("", !0)
  ], 16);
}
const fr = /* @__PURE__ */ v(mr, [["render", hr]]), br = {
  name: "Core:Section",
  static: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [{
    name: "maxWidth",
    type: "number",
    defaultValue: 1200
  }, {
    name: "lazyLoad",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    description: "Only render this section when in view"
  }],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "center"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
}, gr = {
  name: "Slot",
  isRSC: !0,
  description: "Allow child blocks to be inserted into this content when used as a Symbol",
  docsLink: "https://www.builder.io/c/docs/symbols-with-blocks",
  image: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",
  // Maybe wrap this for canHaveChildren so bind children to this hm
  inputs: [{
    name: "name",
    type: "string",
    required: !0,
    defaultValue: "children"
  }],
  shouldReceiveBuilderProps: {
    builderContext: !0,
    builderComponents: !0
  }
}, yr = y({
  name: "builder-slot",
  components: { Blocks: q },
  props: ["builderContext", "name", "builderComponents"]
});
function vr(e, t, n, o, r, i) {
  var l, a, u;
  const s = k("Blocks");
  return d(), h("div", $(
    { style: {
      pointerEvents: "auto"
    } },
    !((l = e.builderContext.context) != null && l.symbolId) && {
      "builder-slot": e.name
    }
  ), [
    E(s, {
      parent: (a = e.builderContext.context) == null ? void 0 : a.symbolId,
      path: `symbol.data.${e.name}`,
      context: e.builderContext,
      registeredComponents: e.builderComponents,
      blocks: (u = e.builderContext.rootState) == null ? void 0 : u[e.name]
    }, null, 8, ["parent", "path", "context", "registeredComponents", "blocks"])
  ], 16);
}
const Sr = /* @__PURE__ */ v(yr, [["render", vr]]), kr = {
  name: "Symbol",
  noWrap: !0,
  static: !0,
  isRSC: !0,
  inputs: [{
    name: "symbol",
    type: "uiSymbol"
  }, {
    name: "dataOnly",
    helperText: "Make this a data symbol that doesn't display any UI",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "inheritState",
    helperText: "Inherit the parent component state and data",
    type: "boolean",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "renderToLiquid",
    helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "useChildren",
    hideFromUI: !0,
    type: "boolean"
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, he = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "10px",
      paddingBottom: "10px",
      minWidth: "100px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      userSelect: "none"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab"
    }
  }
}, fe = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      height: "200px",
      display: "flex",
      marginTop: "20px",
      flexDirection: "column"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab content "
    }
  }
}, Cr = {
  name: "Builder: Tabs",
  inputs: [{
    name: "tabs",
    type: "list",
    broadcast: !0,
    subFields: [{
      name: "label",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [he]
    }, {
      name: "content",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [fe]
    }],
    defaultValue: [{
      label: [{
        ...he,
        component: {
          name: "Text",
          options: {
            text: "Tab 1"
          }
        }
      }],
      content: [{
        ...fe,
        component: {
          name: "Text",
          options: {
            text: "Tab 1 content"
          }
        }
      }]
    }, {
      label: [{
        ...he,
        component: {
          name: "Text",
          options: {
            text: "Tab 2"
          }
        }
      }],
      content: [{
        ...fe,
        component: {
          name: "Text",
          options: {
            text: "Tab 2 content"
          }
        }
      }]
    }]
  }, {
    name: "activeTabStyle",
    type: "uiStyle",
    helperText: "CSS styles for the active tab",
    defaultValue: {
      backgroundColor: "rgba(0, 0, 0, 0.1)"
    }
  }, {
    name: "defaultActiveTab",
    type: "number",
    helperText: 'Default tab to open to. Set to "1" for the first tab, "2" for the second, or choose "0" for none',
    defaultValue: 1,
    advanced: !0
  }, {
    name: "collapsible",
    type: "boolean",
    helperText: "If on, clicking an open tab closes it so no tabs are active",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "tabHeaderLayout",
    type: "enum",
    helperText: "Change the layout of the tab headers (uses justify-content)",
    defaultValue: "flex-start",
    enum: [{
      label: "Center",
      value: "center"
    }, {
      label: "Space between",
      value: "space-between"
    }, {
      label: "Space around",
      value: "space-around"
    }, {
      label: "Left",
      value: "flex-start"
    }, {
      label: "Right",
      value: "flex-end"
    }]
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, Tr = y({
  name: "builder-tabs",
  components: { Blocks: q },
  props: [
    "defaultActiveTab",
    "tabs",
    "activeTabStyle",
    "collapsible",
    "tabHeaderLayout",
    "builderBlock",
    "builderContext",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    return { activeTab: this.defaultActiveTab ? this.defaultActiveTab - 1 : 0 };
  },
  methods: {
    activeTabContent(e) {
      return this.tabs && this.tabs[e].content;
    },
    getTabStyle(e) {
      return e === this.activeTab ? this.activeTabStyle : {};
    },
    onClick(e) {
      e === this.activeTab && this.collapsible ? this.activeTab = -1 : this.activeTab = e;
    }
  }
}), wr = ["onClick"], Ir = { key: 0 };
function $r(e, t, n, o, r, i) {
  const s = k("Blocks");
  return d(), h("div", null, [
    z("div", {
      class: "builder-tabs-wrap",
      style: M({
        display: "flex",
        flexDirection: "row",
        justifyContent: e.tabHeaderLayout || "flex-start",
        overflow: "auto"
      })
    }, [
      (d(!0), h(I, null, F(e.tabs, (l, a) => (d(), h("span", {
        key: a,
        class: Z(`builder-tab-wrap ${e.activeTab === a ? "builder-tab-active" : ""}`),
        style: M(e.getTabStyle(a)),
        onClick: async (u) => e.onClick(a)
      }, [
        E(s, {
          parent: e.builderBlock.id,
          path: `tabs.${a}.label`,
          blocks: l.label,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
      ], 14, wr))), 128))
    ], 4),
    e.activeTabContent(e.activeTab) ? (d(), h("div", Ir, [
      E(s, {
        parent: e.builderBlock.id,
        path: `tabs.${e.activeTab}.content`,
        blocks: e.activeTabContent(e.activeTab),
        context: e.builderContext,
        registeredComponents: e.builderComponents,
        linkComponent: e.builderLinkComponent
      }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
    ])) : C("", !0)
  ]);
}
const Rr = /* @__PURE__ */ v(Tr, [["render", $r]]), Er = {
  shouldReceiveBuilderProps: {},
  name: "Text",
  static: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [{
    name: "text",
    type: "html",
    required: !0,
    autoFocus: !0,
    bubble: !0,
    defaultValue: "Enter some text..."
  }],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}, Ar = y({
  name: "builder-text",
  props: ["text"]
}), Pr = ["innerHTML"];
function Br(e, t, n, o, r, i) {
  var s;
  return d(), h("div", {
    class: "builder-text",
    innerHTML: ((s = e.text) == null ? void 0 : s.toString()) || "",
    style: {
      outline: "none"
    }
  }, null, 8, Pr);
}
const Vr = /* @__PURE__ */ v(Ar, [["render", Br]]), Nr = {
  name: "Custom Code",
  static: !0,
  requiredPermissions: ["editCode"],
  inputs: [{
    name: "code",
    type: "html",
    required: !0,
    defaultValue: "<p>Hello there, I am custom HTML code!</p>",
    code: !0
  }, {
    name: "replaceNodes",
    type: "boolean",
    helperText: "Preserve server rendered dom nodes",
    advanced: !0
  }, {
    name: "scriptsClientOnly",
    type: "boolean",
    defaultValue: !1,
    helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
    advanced: !0
  }]
}, xr = y({
  name: "builder-custom-code",
  props: ["code", "replaceNodes"],
  data() {
    return { scriptsInserted: [], scriptsRun: [] };
  },
  mounted() {
    this.runScripts();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        A() && setTimeout(() => {
          this.runScripts();
        }, 0);
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.code
      };
    }
  },
  methods: {
    runScripts() {
      var t;
      if (!this.$refs.elementRef || !((t = this.$refs.elementRef) != null && t.getElementsByTagName) || typeof window > "u")
        return;
      const e = this.$refs.elementRef.getElementsByTagName("script");
      for (let n = 0; n < e.length; n++) {
        const o = e[n];
        if (o.src) {
          if (this.scriptsInserted.includes(o.src))
            continue;
          this.scriptsInserted.push(o.src);
          const r = document.createElement("script");
          r.async = !0, r.src = o.src, document.head.appendChild(r);
        } else if (!o.type || [
          "text/javascript",
          "application/javascript",
          "application/ecmascript"
        ].includes(o.type)) {
          if (this.scriptsRun.includes(o.innerText))
            continue;
          try {
            this.scriptsRun.push(o.innerText), new Function(o.innerText)();
          } catch (r) {
            B.warn(
              "[BUILDER.IO] `CustomCode`: Error running script:",
              r
            );
          }
        }
      }
    }
  }
}), Wr = ["innerHTML"];
function Dr(e, t, n, o, r, i) {
  return d(), h("div", {
    ref: "elementRef",
    class: Z("builder-custom-code" + (e.replaceNodes ? " replace-nodes" : "")),
    innerHTML: e.code
  }, null, 10, Wr);
}
const Or = /* @__PURE__ */ v(xr, [["render", Dr]]), Ur = {
  name: "Embed",
  static: !0,
  inputs: [{
    name: "url",
    type: "url",
    required: !0,
    defaultValue: "",
    helperText: "e.g. enter a youtube url, google map, etc"
  }, {
    name: "content",
    type: "html",
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: !0
  }]
}, Lr = ["text/javascript", "application/javascript", "application/ecmascript"], Fr = (e) => Lr.includes(e.type), Hr = y({
  name: "builder-embed",
  props: ["content"],
  data() {
    return { scriptsInserted: [], scriptsRun: [], ranInitFn: !1 };
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.$refs.elem && !this.ranInitFn && (this.ranInitFn = !0, this.findAndRunScripts());
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.$refs.elem,
        1: this.ranInitFn
      };
    }
  },
  methods: {
    findAndRunScripts() {
      if (!this.$refs.elem || !this.$refs.elem.getElementsByTagName)
        return;
      const e = this.$refs.elem.getElementsByTagName("script");
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.src && !this.scriptsInserted.includes(n.src)) {
          this.scriptsInserted.push(n.src);
          const o = document.createElement("script");
          o.async = !0, o.src = n.src, document.head.appendChild(o);
        } else if (Fr(n) && !this.scriptsRun.includes(n.innerText))
          try {
            this.scriptsRun.push(n.innerText), new Function(n.innerText)();
          } catch (o) {
            B.warn("[BUILDER.IO] `Embed`: Error running script:", o);
          }
      }
    }
  }
}), Mr = ["innerHTML"];
function jr(e, t, n, o, r, i) {
  return d(), h("div", {
    class: "builder-embed",
    ref: "elem",
    innerHTML: e.content
  }, null, 8, Mr);
}
const Kr = /* @__PURE__ */ v(Hr, [["render", jr]]), qr = {
  name: "Form:Form",
  // editableTags: ['builder-form-error']
  defaults: {
    responsiveStyles: {
      large: {
        marginTop: "15px",
        paddingBottom: "15px"
      }
    }
  },
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
  inputs: [{
    name: "sendSubmissionsTo",
    type: "string",
    // TODO: save to builder data and user can download as csv
    // TODO: easy for mode too or computed add/remove fields form mode
    // so you can edit details and high level mode at same time...
    // Later - more integrations like mailchimp
    // /api/v1/form-submit?to=mailchimp
    enum: [{
      label: "Send to email",
      value: "email",
      helperText: "Send form submissions to the email address of your choosing"
    }, {
      label: "Custom",
      value: "custom",
      helperText: "Handle where the form requests go manually with a little code, e.g. to your own custom backend"
    }],
    defaultValue: "email"
  }, {
    name: "sendSubmissionsToEmail",
    type: "string",
    required: !0,
    // TODO: required: () => options.get("sendSubmissionsTo") === "email"
    defaultValue: "your@email.com",
    showIf: 'options.get("sendSubmissionsTo") === "email"'
  }, {
    name: "sendWithJs",
    type: "boolean",
    helperText: "Set to false to use basic html form action",
    defaultValue: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "name",
    type: "string",
    defaultValue: "My form"
    // advanced: true
  }, {
    name: "action",
    type: "string",
    helperText: "URL to send the form data to",
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "contentType",
    type: "string",
    defaultValue: "application/json",
    advanced: !0,
    // TODO: do automatically if file input
    enum: ["application/json", "multipart/form-data", "application/x-www-form-urlencoded"],
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }, {
    name: "method",
    type: "string",
    showIf: 'options.get("sendSubmissionsTo") === "custom"',
    defaultValue: "POST",
    advanced: !0
  }, {
    name: "previewState",
    type: "string",
    // TODO: persist: false flag
    enum: ["unsubmitted", "sending", "success", "error"],
    defaultValue: "unsubmitted",
    helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "successUrl",
    type: "url",
    helperText: "Optional URL to redirect the user to on form submission success",
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "resetFormOnSubmit",
    type: "boolean",
    showIf: "options.get('sendSubmissionsTo') === 'custom' && options.get('sendWithJs') === true",
    advanced: !0
  }, {
    name: "successMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Thanks!</span>"
        }
      }
    }]
  }, {
    name: "validate",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "errorMessagePath",
    type: "text",
    advanced: !0,
    helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
  }, {
    name: "errorMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      bindings: {
        "component.options.text": "state.formErrorMessage || block.component.options.text"
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Form submission error :( Please check your answers and try again</span>"
        }
      }
    }]
  }, {
    name: "sendingMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Sending...</span>"
        }
      }
    }]
  }, {
    name: "customHeaders",
    type: "map",
    valueType: {
      type: "string"
    },
    advanced: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }],
  noWrap: !0,
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your name</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "name",
        placeholder: "Jane Doe"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your email</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "email",
        placeholder: "jane@doe.com"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:SubmitButton",
      options: {
        text: "Submit"
      }
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, zr = ["production", "qa", "test", "development", "dev", "cdn-qa", "cloud", "fast", "cdn2", "cdn-prod"], Gr = () => {
  const e = process.env.NODE_ENV || "production";
  return zr.includes(e) ? e : "production";
}, Jr = y({
  name: "builder-form-component",
  components: { Blocks: q },
  props: [
    "builderContext",
    "previewState",
    "sendWithJs",
    "sendSubmissionsTo",
    "action",
    "customHeaders",
    "contentType",
    "sendSubmissionsToEmail",
    "name",
    "method",
    "errorMessagePath",
    "resetFormOnSubmit",
    "successUrl",
    "validate",
    "attributes",
    "errorMessage",
    "sendingMessage",
    "successMessage"
  ],
  data() {
    return {
      formState: "unsubmitted",
      responseData: null,
      formErrorMessage: "",
      filterAttrs: x
    };
  },
  methods: {
    mergeNewRootState(e) {
      var n, o;
      const t = {
        ...this.builderContext.rootState,
        ...e
      };
      this.builderContext.rootSetState ? (o = (n = this.builderContext).rootSetState) == null || o.call(n, t) : this.builderContext.rootState = t;
    },
    submissionState() {
      return A() && this.previewState || this.formState;
    },
    errorResponse(e) {
      return JSON.stringify(e, null, 2);
    },
    onSubmit(e) {
      var n;
      const t = this.sendWithJs || this.sendSubmissionsTo === "email";
      if (this.sendSubmissionsTo === "zapier")
        e.preventDefault();
      else if (t) {
        if (!(this.action || this.sendSubmissionsTo === "email")) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        const o = e.currentTarget || e.target, r = this.customHeaders || {};
        let i;
        const s = new FormData(o), l = Array.from(o.querySelectorAll("input,select,textarea")).filter((c) => !!c.name).filter(
          (c) => !!c.name && (c.type !== "radio" || c.checked)
        ).map((c) => {
          let m;
          const b = c.name;
          if (c instanceof HTMLInputElement)
            if (c.type === "radio") {
              if (c.checked)
                return m = c.value, {
                  key: b,
                  value: m
                };
            } else if (c.type === "checkbox")
              m = c.checked;
            else if (c.type === "number" || c.type === "range") {
              const g = c.valueAsNumber;
              isNaN(g) || (m = g);
            } else
              c.type === "file" ? m = c.files : m = c.value;
          else
            m = c.value;
          return {
            key: b,
            value: m
          };
        });
        let a = this.contentType;
        if (this.sendSubmissionsTo === "email" && (a = "multipart/form-data"), Array.from(l).forEach(({ value: c }) => {
          (c instanceof File || Array.isArray(c) && c[0] instanceof File || c instanceof FileList) && (a = "multipart/form-data");
        }), a !== "application/json")
          i = s;
        else {
          const c = {};
          Array.from(l).forEach(({ value: m, key: b }) => {
            et(c, b, m);
          }), i = JSON.stringify(c);
        }
        a && a !== "multipart/form-data" && (t && ((n = this.action) != null && n.includes("zapier.com")) || (r["content-type"] = a));
        const u = new CustomEvent("presubmit", {
          detail: {
            body: i
          }
        });
        if (this.$refs.formRef && (this.$refs.formRef.dispatchEvent(u), u.defaultPrevented))
          return;
        if (this.formState = "sending", this.sendSubmissionsTo === "email" && (this.sendSubmissionsToEmail === "your@email.com" || !this.sendSubmissionsToEmail)) {
          const c = "SubmissionsToEmail is required when sendSubmissionsTo is set to email";
          console.error(c), this.formState = "error", this.mergeNewRootState({
            formErrorMessage: c
          });
          return;
        }
        const p = `${Gr() === "dev" ? "http://localhost:5000" : "https://builder.io"}/api/v1/form-submit?apiKey=${this.builderContext.apiKey}&to=${btoa(
          this.sendSubmissionsToEmail || ""
        )}&name=${encodeURIComponent(this.name || "")}`, f = this.sendSubmissionsTo === "email" ? p : this.action;
        Ie(f), fetch(f, {
          body: i,
          headers: r,
          method: this.method || "post"
        }).then(
          async (c) => {
            var g, P;
            let m;
            const b = c.headers.get("content-type");
            if (b && b.indexOf("application/json") !== -1 ? m = await c.json() : m = await c.text(), !c.ok) {
              const U = new CustomEvent("submit:error", {
                detail: {
                  error: m,
                  status: c.status
                }
              });
              if ((g = this.$refs.formRef) != null && g.nativeElement && ((P = this.$refs.formRef) == null || P.nativeElement.dispatchEvent(
                U
              ), U.defaultPrevented))
                return;
              this.responseData = m, this.formState = "error";
              let V = this.errorMessagePath ? Je(m, this.errorMessagePath) : m.message || m.error || m;
              typeof V != "string" && (V = JSON.stringify(V)), this.formErrorMessage = V, this.mergeNewRootState({
                formErrorMessage: V
              });
              return;
            }
            if (this.responseData = m, this.formState = c.ok ? "success" : "error", c.ok) {
              const U = new CustomEvent("submit:success", {
                detail: {
                  res: c,
                  body: m
                }
              });
              if (this.$refs.formRef) {
                if (this.$refs.formRef.dispatchEvent(U), U.defaultPrevented)
                  return;
                this.resetFormOnSubmit !== !1 && this.$refs.formRef.reset();
              }
              if (this.successUrl)
                if (this.$refs.formRef) {
                  const V = new CustomEvent("route", {
                    detail: {
                      url: this.successUrl
                    }
                  });
                  this.$refs.formRef.dispatchEvent(V), V.defaultPrevented || (location.href = this.successUrl);
                } else
                  location.href = this.successUrl;
            }
          },
          (c) => {
            const m = new CustomEvent("submit:error", {
              detail: {
                error: c
              }
            });
            this.$refs.formRef && (this.$refs.formRef.dispatchEvent(m), m.defaultPrevented) || (this.responseData = c, this.formState = "error");
          }
        );
      }
    }
  }
}), Qr = ["validate", "action", "method", "name"], Yr = {
  key: 2,
  class: "builder-form-error-text pre-2oa2wtipkzk"
};
function Xr(e, t, n, o, r, i) {
  const s = k("Blocks");
  return d(), h("form", $({
    validate: e.validate,
    ref: "formRef",
    action: !e.sendWithJs && e.action,
    method: e.method,
    name: e.name,
    onSubmit: t[0] || (t[0] = async (l) => e.onSubmit(l))
  }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    N(e.$slots, "default", {}, void 0, !0),
    e.submissionState() === "error" ? (d(), S(s, {
      key: 0,
      path: "errorMessage",
      blocks: e.errorMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : C("", !0),
    e.submissionState() === "sending" ? (d(), S(s, {
      key: 1,
      path: "sendingMessage",
      blocks: e.sendingMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : C("", !0),
    e.submissionState() === "error" && e.responseData ? (d(), h("pre", Yr, ce(e.errorResponse(e.responseData)), 1)) : C("", !0),
    e.submissionState() === "success" ? (d(), S(s, {
      key: 3,
      path: "successMessage",
      blocks: e.successMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : C("", !0)
  ], 16, Qr);
}
const _r = /* @__PURE__ */ v(Jr, [["render", Xr], ["__scopeId", "data-v-77c7888c"]]), Zr = {
  name: "Form:Input",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
  inputs: [
    {
      name: "type",
      type: "text",
      enum: ["text", "number", "email", "url", "checkbox", "radio", "range", "date", "datetime-local", "search", "tel", "time", "file", "month", "week", "password", "color", "hidden"],
      defaultValue: "text"
    },
    {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
    },
    {
      name: "placeholder",
      type: "string",
      defaultValue: "Hello there",
      helperText: "Text to display when there is no value"
    },
    // TODO: handle value vs default value automatically like ng-model
    {
      name: "defaultValue",
      type: "string"
    },
    {
      name: "value",
      type: "string",
      advanced: !0
    },
    {
      name: "required",
      type: "boolean",
      helperText: "Is this input required to be filled out to submit a form",
      defaultValue: !1
    }
  ],
  noWrap: !0,
  static: !0,
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  }
}, ei = y({
  name: "builder-form-input-component",
  props: [
    "attributes",
    "defaultValue",
    "placeholder",
    "type",
    "name",
    "value",
    "required"
  ],
  data() {
    return { isEditing: A, filterAttrs: x };
  }
}), ti = ["placeholder", "type", "name", "value", "defaultValue", "required"];
function ni(e, t, n, o, r, i) {
  return d(), h("input", $({
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    placeholder: e.placeholder,
    type: e.type,
    name: e.name,
    value: e.value,
    defaultValue: e.defaultValue,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, ti);
}
const oi = /* @__PURE__ */ v(ei, [["render", ni]]), ri = {
  name: "Form:Select",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  defaultStyles: {
    alignSelf: "flex-start"
  },
  inputs: [{
    name: "options",
    type: "list",
    required: !0,
    subFields: [{
      name: "value",
      type: "text",
      required: !0
    }, {
      name: "name",
      type: "text"
    }],
    defaultValue: [{
      value: "option 1"
    }, {
      value: "option 2"
    }]
  }, {
    name: "name",
    type: "string",
    required: !0,
    helperText: 'Every select in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "value",
    type: "string",
    advanced: !0
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  static: !0,
  noWrap: !0
}, ii = y({
  name: "builder-select-component",
  props: ["attributes", "value", "defaultValue", "name", "required", "options"],
  data() {
    return { isEditing: A, filterAttrs: x };
  }
}), si = ["value", "defaultValue", "name", "required"], ai = ["value"];
function li(e, t, n, o, r, i) {
  return d(), h("select", $({
    value: e.value,
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    defaultValue: e.defaultValue,
    name: e.name,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    (d(!0), h(I, null, F(e.options, (s, l) => (d(), h("option", {
      key: `${s.name}-${l}`,
      value: s.value
    }, ce(s.name || s.value), 9, ai))), 128))
  ], 16, si);
}
const ci = /* @__PURE__ */ v(ii, [["render", li]]), di = {
  name: "Form:SubmitButton",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#3898EC",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me"
  }],
  static: !0,
  noWrap: !0
  // TODO: optional children? maybe as optional form input
  // that only shows if advanced setting is flipped
  // TODO: defaultChildren
  // canHaveChildren: true,
}, ui = y({
  name: "builder-submit-button",
  props: ["attributes", "text"],
  data() {
    return { filterAttrs: x };
  }
});
function pi(e, t, n, o, r, i) {
  return d(), h("button", $({ type: "submit" }, e.filterAttrs(e.attributes, "v-on:", !1), L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), ce(e.text), 17);
}
const mi = /* @__PURE__ */ v(ui, [["render", pi]]), hi = {
  name: "Form:TextArea",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",
  inputs: [{
    advanced: !0,
    name: "value",
    type: "string"
  }, {
    name: "name",
    type: "string",
    required: !0,
    helperText: 'Every input in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "placeholder",
    type: "string",
    defaultValue: "Hello there"
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  },
  static: !0,
  noWrap: !0
}, fi = y({
  name: "builder-textarea",
  props: [
    "attributes",
    "placeholder",
    "name",
    "value",
    "defaultValue",
    "required"
  ],
  data() {
    return { filterAttrs: x };
  }
}), bi = ["placeholder", "name", "value", "defaultValue", "required"];
function gi(e, t, n, o, r, i) {
  return d(), h("textarea", $({
    placeholder: e.placeholder,
    name: e.name,
    value: e.value,
    defaultValue: e.defaultValue,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, bi);
}
const yi = /* @__PURE__ */ v(fi, [["render", gi]]), vi = {
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [{
    name: "image",
    bubble: !0,
    type: "file",
    allowedFileTypes: Pe,
    required: !0
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    enum: [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "title",
    type: "string",
    helperText: "Text to display when hovering over the asset"
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: 0.7041
  }],
  noWrap: !0
}, Si = y({
  name: "builder-img-component",
  props: [
    "imgSrc",
    "image",
    "attributes",
    "altText",
    "title",
    "backgroundSize",
    "backgroundPosition",
    "aspectRatio"
  ],
  data() {
    return { isEditing: A };
  },
  computed: {
    srcSetToUse() {
      const e = this.imgSrc || this.image;
      if (!(!e || typeof e != "string") && e.match(/builder\.io/))
        return oe(e);
    },
    imgAttrs() {
      const e = {
        ...x(this.attributes, "v-on:", !1),
        ...x(this.attributes, "v-on:", !0),
        [j()]: `builder-raw-img ${this.attributes[j()] || ""}`
      };
      return delete e.style, e;
    }
  }
}), ki = ["alt", "title", "src"];
function Ci(e, t, n, o, r, i) {
  var s;
  return d(), h("img", $({
    loading: "lazy",
    key: e.isEditing() && e.imgSrc || "default-key",
    alt: e.altText,
    title: e.title,
    src: e.imgSrc || e.image,
    style: {
      objectFit: e.backgroundSize || "cover",
      objectPosition: e.backgroundPosition || "center",
      aspectRatio: e.aspectRatio || void 0,
      ...((s = e.attributes) == null ? void 0 : s.style) || {}
    }
  }, e.imgAttrs), null, 16, ki);
}
const Ti = /* @__PURE__ */ v(Si, [["render", Ci]]), wi = {
  name: "Video",
  canHaveChildren: !0,
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px"
  },
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [{
    name: "video",
    type: "file",
    allowedFileTypes: dr,
    bubble: !0,
    defaultValue: "https://cdn.builder.io/o/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd27731a526464deba0016216f5f9e570%2Fcompressed?apiKey=YJIGb4i01jvw0SRdL5Bt&token=d27731a526464deba0016216f5f9e570&alt=media&optimized=true",
    required: !0
  }, {
    name: "posterImage",
    type: "file",
    allowedFileTypes: Pe,
    helperText: "Image to show before the video plays"
  }, {
    name: "autoPlay",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "controls",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "muted",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "loop",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "playsInline",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "fit",
    type: "text",
    defaultValue: "cover",
    enum: ["contain", "cover", "fill", "auto"]
  }, {
    name: "preload",
    type: "text",
    defaultValue: "metadata",
    enum: ["auto", "metadata", "none"]
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "position",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "height",
    type: "number",
    advanced: !0
  }, {
    name: "width",
    type: "number",
    advanced: !0
  }, {
    name: "aspectRatio",
    type: "number",
    advanced: !0,
    defaultValue: 0.7004048582995948
  }, {
    name: "lazyLoad",
    type: "boolean",
    helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
    defaultValue: !0,
    advanced: !0
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0
  }
}, Ii = y({
  name: "builder-video",
  props: [
    "lazyLoad",
    "autoPlay",
    "muted",
    "controls",
    "loop",
    "playsInline",
    "preload",
    "attributes",
    "fit",
    "position",
    "aspectRatio",
    "posterImage",
    "video",
    "fitContent",
    "builderBlock"
  ],
  data() {
    return { lazyVideoObserver: void 0 };
  },
  mounted() {
    if (this.lazyLoad) {
      const e = new IntersectionObserver(function(t) {
        t.forEach(function(n) {
          if (!n.isIntersecting)
            return;
          const o = n.target;
          try {
            Array.from(o.children).filter(
              (r) => r instanceof HTMLElement && r.tagName === "SOURCE"
            ).forEach((r) => {
              const i = r.dataset.src;
              i && (r.src = i);
            }), o.load(), e.unobserve(o);
          } catch (r) {
            console.error("Error loading lazy video:", r);
          }
        });
      });
      this.$refs.videoRef && e.observe(this.$refs.videoRef), this.lazyVideoObserver = e;
    }
  },
  unmounted() {
    this.lazyVideoObserver && this.lazyVideoObserver.disconnect();
  },
  computed: {
    videoProps() {
      return {
        ...this.autoPlay === !0 ? {
          autoPlay: !0
        } : {},
        ...this.muted === !0 ? {
          muted: !0
        } : {},
        ...this.controls === !0 ? {
          controls: !0
        } : {},
        ...this.loop === !0 ? {
          loop: !0
        } : {},
        ...this.playsInline === !0 ? {
          playsInline: !0
        } : {}
      };
    },
    spreadProps() {
      return {
        ...this.videoProps
      };
    }
  }
}), $i = { style: {
  position: "relative"
} }, Ri = ["preload", "poster"], Ei = {
  key: 1,
  style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }
}, Ai = {
  key: 2,
  style: {
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
};
function Pi(e, t, n, o, r, i) {
  var s, l, a, u, p, f, c;
  return d(), h("div", $i, [
    z("video", $({
      class: "builder-video",
      ref: "videoRef",
      preload: e.lazyLoad ? "none" : e.preload || "metadata",
      style: {
        width: "100%",
        height: "100%",
        ...(s = e.attributes) == null ? void 0 : s.style,
        objectFit: e.fit,
        objectPosition: e.position,
        // Hack to get object fit to work as expected and
        // not have the video overflow
        borderRadius: "1px",
        ...e.aspectRatio ? {
          position: "absolute"
        } : null
      },
      poster: e.posterImage
    }, e.spreadProps), [
      z("source", $(
        { type: "video/mp4" },
        e.lazyLoad ? {
          "data-src": e.video
        } : {
          src: e.video
        }
      ), null, 16)
    ], 16, Ri),
    e.aspectRatio && !(e.fitContent && ((a = (l = e.builderBlock) == null ? void 0 : l.children) != null && a.length)) ? (d(), h("div", {
      key: 0,
      style: M({
        width: "100%",
        paddingTop: e.aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px"
      })
    }, null, 4)) : C("", !0),
    (p = (u = e.builderBlock) == null ? void 0 : u.children) != null && p.length && e.fitContent ? (d(), h("div", Ei, [
      N(e.$slots, "default")
    ])) : C("", !0),
    (c = (f = e.builderBlock) == null ? void 0 : f.children) != null && c.length && !e.fitContent ? (d(), h("div", Ai, [
      N(e.$slots, "default")
    ])) : C("", !0)
  ]);
}
const Bi = /* @__PURE__ */ v(Ii, [["render", Pi]]), Vi = () => [{
  component: Or,
  ...Nr
}, {
  component: Kr,
  ...Ur
}, {
  component: _r,
  ...qr
}, {
  component: oi,
  ...Zr
}, {
  component: mi,
  ...di
}, {
  component: ci,
  ...ri
}, {
  component: yi,
  ...hi
}, {
  component: Ti,
  ...vi
}, {
  component: Bi,
  ...wi
}], je = () => [{
  component: Ft,
  ...ar
}, {
  component: Po,
  ...lr
}, {
  component: No,
  ...cr
}, {
  component: Ho,
  ...ur
}, {
  component: Ko,
  ...br
}, {
  component: Sr,
  ...gr
}, {
  component: bs,
  ...kr
}, {
  component: Vr,
  ...Er
}, ...$t.includes(R) ? [{
  component: fr,
  ...pr
}] : [], {
  component: Rr,
  ...Cr
}, {
  component: sr,
  ...tr
}, ...Vi()], Ni = `function updateCookiesAndStyles(contentId, variants, isHydrationTarget, isAngularSDK) {
  function getAndSetVariantId() {
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; Secure; SameSite=None';
    }
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    const cookieName = \`builder.tests.\${contentId}\`;
    const variantInCookie = getCookie(cookieName);
    const availableIDs = variants.map(vr => vr.id).concat(contentId);
    if (variantInCookie && availableIDs.includes(variantInCookie)) {
      return variantInCookie;
    }
    let n = 0;
    const random = Math.random();
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const testRatio = variant.testRatio;
      n += testRatio;
      if (random < n) {
        setCookie(cookieName, variant.id);
        return variant.id;
      }
    }
    setCookie(cookieName, contentId);
    return contentId;
  }
  const winningVariantId = getAndSetVariantId();
  let styleEl = document.currentScript?.previousElementSibling;
  if (isAngularSDK) {
    styleEl = document.currentScript?.parentElement?.previousElementSibling?.querySelector('style');
  }
  if (isHydrationTarget) {
    styleEl.remove();
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  } else {
    const newStyleStr = variants.concat({
      id: contentId
    }).filter(variant => variant.id !== winningVariantId).map(value => {
      return \`.variant-\${value.id} {  display: none; }
        \`;
    }).join('');
    styleEl.innerHTML = newStyleStr;
  }
}`, xi = `function updateVariantVisibility(variantContentId, defaultContentId, isHydrationTarget) {
  if (!navigator.cookieEnabled) {
    return;
  }
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const cookieName = \`builder.tests.\${defaultContentId}\`;
  const winningVariant = getCookie(cookieName);
  const parentDiv = document.currentScript?.parentElement;
  const isDefaultContent = variantContentId === defaultContentId;
  const isWinningVariant = winningVariant === variantContentId;
  if (isWinningVariant && !isDefaultContent) {
    parentDiv?.removeAttribute('hidden');
    parentDiv?.removeAttribute('aria-hidden');
  } else if (!isWinningVariant && isDefaultContent) {
    parentDiv?.setAttribute('hidden', 'true');
    parentDiv?.setAttribute('aria-hidden', 'true');
  }
  if (isHydrationTarget) {
    if (!isWinningVariant) {
      parentDiv?.remove();
    }
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  }
  return;
}`, At = "builderIoAbTest", Pt = "builderIoRenderContent", ie = (e) => Object.values((e == null ? void 0 : e.variations) || {}).map((t) => ({
  ...t,
  testVariationId: t.id,
  id: e == null ? void 0 : e.id
})), Wi = ({
  canTrack: e,
  content: t
}) => !(!(ie(t).length > 0) || !e), Di = (e) => e === "react" || e === "reactNative", Oi = R === "angular", Bt = Di(R), Ui = () => `
  window.${At} = ${Ni}
  window.${Pt} = ${xi}
  `, Li = (e, t) => `
  window.${At}(
    "${t}",${JSON.stringify(e)}, ${Bt}, ${Oi}
  )`, Fi = ({
  contentId: e,
  variationId: t
}) => `window.${Pt}(
    "${t}", "${e}", ${Bt}
  )`;
function Ke(e) {
  return Math.round(e * 1e3) / 1e3;
}
const Hi = (e, t, n = !0) => {
  if (!(e instanceof HTMLElement))
    return null;
  let o = n ? e : e.parentElement;
  do {
    if (!o)
      return null;
    if (t(o))
      return o;
  } while (o = o.parentElement);
  return null;
}, Mi = (e) => Hi(e, (t) => {
  const n = t.getAttribute("builder-id") || t.id;
  return (n == null ? void 0 : n.indexOf("builder-")) === 0;
}), qe = ({
  event: e,
  target: t
}) => {
  const n = t.getBoundingClientRect(), o = e.clientX - n.left, r = e.clientY - n.top, i = Ke(o / n.width), s = Ke(r / n.height);
  return {
    x: i,
    y: s
  };
}, ji = (e) => {
  const t = e.target, n = t && Mi(t), o = (n == null ? void 0 : n.getAttribute("builder-id")) || (n == null ? void 0 : n.id);
  return {
    targetBuilderElement: o || void 0,
    metadata: {
      targetOffset: t ? qe({
        event: e,
        target: t
      }) : void 0,
      builderTargetOffset: n ? qe({
        event: e,
        target: n
      }) : void 0,
      builderElementIndex: n && o ? [].slice.call(document.getElementsByClassName(o)).indexOf(n) : void 0
    }
  };
}, Ki = ["svelte", "qwik", "vue"], qi = () => Ki.includes(R) && (A() || Te()), zi = (e) => {
  var i;
  const t = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""), n = t.split(",")[0], o = e.fileUrl ?? ((i = e == null ? void 0 : e.files) == null ? void 0 : i.regular);
  let r = "";
  if (o && t && n && (r += `
@font-face {
font-family: "${t}";
src: local("${n}"), url('${o}') format('woff2');
font-display: fallback;
font-weight: 400;
}
      `.trim()), e.files)
    for (const s in e.files) {
      if (!(String(Number(s)) === s))
        continue;
      const a = e.files[s];
      a && a !== o && (r += `
@font-face {
font-family: "${t}";
src: url('${a}') format('woff2');
font-display: fallback;
font-weight: ${s};
}
        `.trim());
    }
  return r;
}, Gi = ({
  customFonts: e
}) => {
  var t;
  return ((t = e == null ? void 0 : e.map((n) => zi(n))) == null ? void 0 : t.join(" ")) || "";
}, Ji = ({
  cssCode: e,
  contentId: t
}) => e ? t ? (e == null ? void 0 : e.replace(/&/g, `div[builder-content-id="${t}"]`)) || "" : e : "", Qi = `
.builder-button {
  all: unset;
}

.builder-text > p:first-of-type, .builder-text > .builder-paragraph:first-of-type {
  margin: 0;
}
.builder-text > p, .builder-text > .builder-paragraph {
  color: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: inherit;
  font-family: inherit;
}
`, Yi = (e) => e ? "" : Qi, Xi = (e) => `variant-${e}`, _i = y({
  name: "enable-editor",
  components: { DynamicDiv: te },
  props: [
    "isNestedRender",
    "builderContextSignal",
    "canTrack",
    "apiKey",
    "apiHost",
    "locale",
    "enrich",
    "trustedHosts",
    "model",
    "content",
    "context",
    "data",
    "showContent",
    "contentWrapper",
    "contentWrapperProps"
  ],
  data() {
    return {
      hasExecuted: !1,
      contextValue: this.builderContextSignal,
      prevData: null,
      prevLocale: "",
      ContentWrapper: this.contentWrapper || "div",
      httpReqsData: {},
      httpReqsPending: {},
      clicked: !1,
      builderContext: be,
      needsElementRefDivForEditing: qi,
      getWrapperClassName: Xi
    };
  },
  provide() {
    const e = this;
    return {
      [be.key]: e.builderContextSignal
    };
  },
  created() {
    this.runHttpRequests(), this.emitStateUpdate();
  },
  mounted() {
    var e, t, n;
    if (T()) {
      A() && !this.isNestedRender && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
        new CustomEvent("initeditingbldr")
      );
      const o = this.builderContextSignal.content && G(this.canTrack), r = de({
        name: `builder.tests.${(e = this.builderContextSignal.content) == null ? void 0 : e.id}`,
        canTrack: !0
      }), i = (t = this.builderContextSignal.content) == null ? void 0 : t.testVariationId;
      if (o && i === r) {
        const s = (n = this.builderContextSignal.content) == null ? void 0 : n.id, l = this.apiKey;
        ye({
          apiHost: this.apiHost,
          type: "impression",
          canTrack: !0,
          contentId: s,
          apiKey: l,
          variationId: r !== s ? r : void 0
        });
      }
      Te() && !A() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
        new CustomEvent("initpreviewingbldr")
      );
    }
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.content && this.mergeNewContent(this.content);
      },
      immediate: !0
    },
    onUpdateHook1: {
      handler() {
        this.emitStateUpdate();
      },
      immediate: !0
    },
    onUpdateHook2: {
      handler() {
        if (this.data) {
          if (this.prevData === this.data)
            return;
          this.mergeNewRootState(this.data), this.prevData = this.data;
        }
      },
      immediate: !0
    },
    onUpdateHook3: {
      handler() {
        if (this.locale) {
          if (this.prevLocale === this.locale)
            return;
          this.mergeNewRootState({
            locale: this.locale
          }), this.prevLocale = this.locale;
        }
      },
      immediate: !0
    }
  },
  unmounted() {
    T() && (window.removeEventListener("message", this.processMessage), window.removeEventListener(
      "builder:component:stateChangeListenerActivated",
      this.emitStateUpdate
    ));
  },
  computed: {
    showContentProps() {
      return this.showContent ? {} : {
        hidden: !0,
        "aria-hidden": !0
      };
    },
    onUpdateHook0() {
      return {
        0: this.content
      };
    },
    onUpdateHook1() {
      return {
        0: this.builderContextSignal.rootState
      };
    },
    onUpdateHook2() {
      return {
        0: this.data
      };
    },
    onUpdateHook3() {
      return {
        0: this.locale
      };
    }
  },
  methods: {
    mergeNewRootState(e, t) {
      var o, r;
      const n = {
        ...this.builderContextSignal.rootState,
        ...e
      };
      this.builderContextSignal.rootSetState ? (r = (o = this.builderContextSignal).rootSetState) == null || r.call(o, n) : this.builderContextSignal.rootState = n, this.builderContextSignal.rootSetState ? this.builderContextSignal.rootSetState(n) : this.builderContextSignal.rootState = n;
    },
    mergeNewContent(e, t) {
      var o, r, i, s, l;
      const n = {
        ...this.builderContextSignal.content,
        ...e,
        data: {
          ...(o = this.builderContextSignal.content) == null ? void 0 : o.data,
          ...e == null ? void 0 : e.data
        },
        meta: {
          ...(r = this.builderContextSignal.content) == null ? void 0 : r.meta,
          ...e == null ? void 0 : e.meta,
          breakpoints: ((i = e == null ? void 0 : e.meta) == null ? void 0 : i.breakpoints) || ((l = (s = this.builderContextSignal.content) == null ? void 0 : s.meta) == null ? void 0 : l.breakpoints)
        }
      };
      this.builderContextSignal.content = n;
    },
    processMessage(e) {
      return ut({
        model: this.model,
        trustedHosts: this.trustedHosts,
        callbacks: {
          configureSdk: (t) => {
            var r;
            const { breakpoints: n, contentId: o } = t;
            !o || o !== ((r = this.builderContextSignal.content) == null ? void 0 : r.id) || n && this.mergeNewContent({
              meta: {
                breakpoints: n
              }
            });
          },
          animation: (t) => {
            yt(t);
          },
          contentUpdate: (t, n) => {
            this.mergeNewContent(t, n);
          },
          stateUpdate: (t, n) => {
            this.mergeNewRootState(t, n);
          }
        }
      })(e);
    },
    onClick(e) {
      var t, n;
      if (this.builderContextSignal.content) {
        const o = (t = this.builderContextSignal.content) == null ? void 0 : t.testVariationId, r = (n = this.builderContextSignal.content) == null ? void 0 : n.id;
        ye({
          apiHost: this.apiHost,
          type: "click",
          canTrack: G(this.canTrack),
          contentId: r,
          apiKey: this.apiKey,
          variationId: o !== r ? o : void 0,
          ...ji(e),
          unique: !this.clicked
        });
      }
      this.clicked || (this.clicked = !0);
    },
    runHttpRequests() {
      var t, n;
      const e = ((n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.httpRequests) ?? {};
      Object.entries(e).forEach(
        ([o, r]) => {
          if (!r)
            return;
          const i = typeof r == "object" && r["@type"] === "@builder.io/core:Request";
          if (this.httpReqsPending[o] || this.httpReqsData[o] && !A())
            return;
          const s = i ? r.request.url : r;
          this.httpReqsPending[o] = !0;
          const l = s.replace(
            /{{([^}]+)}}/g,
            (p, f) => String(
              ee({
                code: f,
                context: this.context || {},
                localState: void 0,
                rootState: this.builderContextSignal.rootState,
                rootSetState: this.builderContextSignal.rootSetState
              })
            )
          ), a = i ? {
            url: l,
            method: r.request.method,
            headers: r.request.headers,
            body: r.request.body
          } : {
            url: l,
            method: "GET"
          };
          Ie(JSON.stringify(a));
          const u = {
            method: a.method,
            headers: a.headers,
            body: a.body
          };
          a.method === "GET" && delete u.body, fetch(a.url, u).then((p) => p.json()).then((p) => {
            this.mergeNewRootState({
              [o]: p
            }), this.httpReqsData[o] = !0;
          }).catch((p) => {
            console.error(
              "error fetching dynamic data",
              JSON.stringify(r),
              p
            );
          }).finally(() => {
            this.httpReqsPending[o] = !1;
          });
        }
      );
    },
    emitStateUpdate() {
      A() && window.dispatchEvent(
        new CustomEvent(
          "builder:component:stateChange",
          {
            detail: {
              state: Ce(this.builderContextSignal.rootState),
              ref: {
                name: this.model
              }
            }
          }
        )
      );
    },
    elementRef_onIniteditingbldr(e) {
      window.addEventListener("message", this.processMessage), dt({
        ...this.locale ? {
          locale: this.locale
        } : {},
        ...this.enrich ? {
          enrich: this.enrich
        } : {},
        ...this.trustedHosts ? {
          trustedHosts: this.trustedHosts
        } : {},
        modelName: this.model ?? "",
        apiKey: this.apiKey
      }), Object.values(
        this.builderContextSignal.componentInfos
      ).forEach((t) => {
        var n, o;
        if (!((n = t.models) != null && n.length) || t.models.includes(this.model)) {
          const r = mn(t);
          (o = window.parent) == null || o.postMessage(r, "*");
        }
      }), window.addEventListener(
        "builder:component:stateChangeListenerActivated",
        this.emitStateUpdate
      );
    },
    elementRef_onInitpreviewingbldr(e) {
      var i;
      const t = new URL(location.href).searchParams, n = t.get("builder.preview"), o = t.get(
        `builder.overrides.${n}`
      ), r = t.get("apiKey") || t.get("builder.space");
      (n === "BUILDER_STUDIO" || n === this.model && r === this.apiKey && (!this.content || o === this.content.id)) && Ee({
        model: this.model,
        apiKey: this.apiKey,
        apiVersion: this.builderContextSignal.apiVersion,
        ...n === "BUILDER_STUDIO" && ((i = this.context) != null && i.symbolId) ? {
          query: {
            id: this.context.symbolId
          }
        } : {}
      }).then((s) => {
        s && this.mergeNewContent(s);
      });
    }
  }
});
function Zi(e, t, n, o, r, i) {
  var s, l, a;
  return e.builderContextSignal.content || e.needsElementRefDivForEditing() ? (d(), S(X(e.ContentWrapper), $({
    key: 0,
    ref: "elementRef",
    onClick: (u) => e.onClick(u),
    "builder-content-id": (s = e.builderContextSignal.content) == null ? void 0 : s.id,
    "builder-model": e.model,
    className: e.getWrapperClassName(((l = e.content) == null ? void 0 : l.testVariationId) || ((a = e.content) == null ? void 0 : a.id)),
    style: {
      display: !e.builderContextSignal.content && e.needsElementRefDivForEditing() ? "none" : void 0
    },
    onIniteditingbldr: (u) => e.elementRef_onIniteditingbldr(u),
    onInitpreviewingbldr: (u) => e.elementRef_onInitpreviewingbldr(u)
  }, { ...e.showContentProps, ...e.contentWrapperProps }), {
    default: O(() => [
      N(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["onClick", "builder-content-id", "builder-model", "className", "style", "onIniteditingbldr", "onInitpreviewingbldr"])) : C("", !0);
}
const es = /* @__PURE__ */ v(_i, [["render", Zi]]), ts = y({
  name: "content-styles",
  components: { InlinedStyles: ue },
  props: ["cssCode", "contentId", "customFonts", "isNestedRender", "nonce"],
  data() {
    return {
      injectedStyles: `
${Ji({
        cssCode: this.cssCode,
        contentId: this.contentId
      })}
${Gi({
        customFonts: this.customFonts
      })}
${Yi(this.isNestedRender)}
`.trim()
    };
  }
});
function ns(e, t, n, o, r, i) {
  const s = k("InlinedStyles");
  return d(), S(s, {
    id: "builderio-content",
    styles: e.injectedStyles,
    nonce: e.nonce
  }, null, 8, ["styles", "nonce"]);
}
const os = /* @__PURE__ */ v(ts, [["render", ns]]), rs = ({
  content: e,
  data: t,
  locale: n
}) => {
  var i, s, l;
  const o = {}, r = ((i = e == null ? void 0 : e.data) == null ? void 0 : i.state) || {};
  return (l = (s = e == null ? void 0 : e.data) == null ? void 0 : s.inputs) == null || l.forEach((a) => {
    a.name && a.defaultValue !== void 0 && (o[a.name] = a.defaultValue);
  }), {
    ...o,
    ...r,
    ...t,
    ...n ? {
      locale: n
    } : {}
  };
}, is = ({
  content: e,
  data: t
}) => e ? {
  ...e,
  data: {
    ...e == null ? void 0 : e.data,
    ...t
  },
  meta: e == null ? void 0 : e.meta
} : void 0, ss = Nt, as = y({
  name: "content-component",
  components: {
    EnableEditor: es,
    InlinedScript: Be,
    ContentStyles: os,
    Blocks: q,
    DynamicDiv: te
  },
  props: [
    "apiKey",
    "context",
    "content",
    "customComponents",
    "data",
    "locale",
    "canTrack",
    "apiVersion",
    "blocksWrapper",
    "blocksWrapperProps",
    "nonce",
    "model",
    "apiHost",
    "enrich",
    "showContent",
    "contentWrapper",
    "contentWrapperProps",
    "trustedHosts",
    "isNestedRender",
    "isSsrAbTest",
    "linkComponent"
  ],
  data() {
    var e, t;
    return {
      scriptStr: Fi({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        variationId: (e = this.content) == null ? void 0 : e.testVariationId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        contentId: (t = this.content) == null ? void 0 : t.id
      }),
      registeredComponents: [
        ...je(),
        ...this.customComponents || []
      ].reduce(
        (n, { component: o, ...r }) => ({
          ...n,
          [r.name]: {
            component: ss(o),
            ...ae(r)
          }
        }),
        {}
      ),
      builderContextSignal: {
        content: is({
          content: this.content,
          data: this.data
        }),
        localState: void 0,
        rootState: rs({
          content: this.content,
          data: this.data,
          locale: this.locale
        }),
        rootSetState: this.contentSetState,
        context: this.context || {},
        canTrack: this.canTrack,
        apiKey: this.apiKey,
        apiVersion: this.apiVersion,
        componentInfos: [
          ...je(),
          ...this.customComponents || []
        ].reduce(
          (n, { component: o, ...r }) => ({
            ...n,
            [r.name]: ae(r)
          }),
          {}
        ),
        inheritedStyles: {},
        BlocksWrapper: this.blocksWrapper || "div",
        BlocksWrapperProps: this.blocksWrapperProps || {},
        nonce: this.nonce || "",
        model: this.model
      },
      TARGET: R
    };
  },
  provide() {
    const e = this;
    return {
      [Ge.key]: {
        registeredComponents: e.registeredComponents
      }
    };
  },
  created() {
    var t, n;
    this.apiKey || B.error(
      "No API key provided to `Content` component. This can cause issues. Please provide an API key using the `apiKey` prop."
    );
    const e = (n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.jsCode;
    e && ee({
      code: e,
      context: this.context || {},
      localState: void 0,
      rootState: this.builderContextSignal.rootState,
      rootSetState: (o) => {
        this.builderContextSignal.rootState = o;
      },
      isExpression: !1
    });
  },
  methods: {
    contentSetState(e) {
      this.builderContextSignal.rootState = e;
    }
  }
});
function ls(e, t, n, o, r, i) {
  const s = k("InlinedScript"), l = k("ContentStyles"), a = k("Blocks"), u = k("EnableEditor");
  return d(), S(u, $({
    apiHost: e.apiHost,
    nonce: e.nonce,
    content: e.content,
    data: e.data,
    model: e.model,
    context: e.context,
    apiKey: e.apiKey,
    canTrack: e.canTrack,
    locale: e.locale,
    enrich: e.enrich,
    showContent: e.showContent,
    builderContextSignal: e.builderContextSignal,
    contentWrapper: e.contentWrapper,
    contentWrapperProps: e.contentWrapperProps,
    trustedHosts: e.trustedHosts,
    isNestedRender: e.isNestedRender
  }, {}), {
    default: O(() => {
      var p, f, c, m, b, g, P;
      return [
        e.isSsrAbTest ? (d(), S(s, {
          key: 0,
          id: "builderio-variant-visibility",
          scriptStr: e.scriptStr,
          nonce: e.nonce || ""
        }, null, 8, ["scriptStr", "nonce"])) : C("", !0),
        e.TARGET !== "reactNative" ? (d(), S(l, {
          key: 1,
          nonce: e.nonce || "",
          isNestedRender: e.isNestedRender,
          contentId: (p = e.builderContextSignal.content) == null ? void 0 : p.id,
          cssCode: (c = (f = e.builderContextSignal.content) == null ? void 0 : f.data) == null ? void 0 : c.cssCode,
          customFonts: (b = (m = e.builderContextSignal.content) == null ? void 0 : m.data) == null ? void 0 : b.customFonts
        }, null, 8, ["nonce", "isNestedRender", "contentId", "cssCode", "customFonts"])) : C("", !0),
        E(a, {
          blocks: (P = (g = e.builderContextSignal.content) == null ? void 0 : g.data) == null ? void 0 : P.blocks,
          context: e.builderContextSignal,
          registeredComponents: e.registeredComponents,
          linkComponent: e.linkComponent
        }, null, 8, ["blocks", "context", "registeredComponents", "linkComponent"])
      ];
    }),
    _: 1
  }, 16, ["apiHost", "nonce", "content", "data", "model", "context", "apiKey", "canTrack", "locale", "enrich", "showContent", "builderContextSignal", "contentWrapper", "contentWrapperProps", "trustedHosts", "isNestedRender"]);
}
const cs = /* @__PURE__ */ v(as, [["render", ls]]), ds = y({
  name: "content-variants",
  components: {
    InlinedScript: Be,
    InlinedStyles: ue,
    ContentComponent: cs
  },
  props: [
    "canTrack",
    "content",
    "isNestedRender",
    "nonce",
    "apiHost",
    "model",
    "data",
    "context",
    "apiKey",
    "apiVersion",
    "customComponents",
    "linkComponent",
    "locale",
    "enrich",
    "blocksWrapper",
    "blocksWrapperProps",
    "contentWrapper",
    "contentWrapperProps",
    "trustedHosts"
  ],
  data() {
    return {
      shouldRenderVariants: Wi({
        canTrack: G(this.canTrack),
        content: this.content
      }),
      SDKS_SUPPORTING_PERSONALIZATION: $t,
      getInitPersonalizationVariantsFnsScriptString: _o,
      TARGET: R,
      getInitVariantsFnsScriptString: Ui,
      getVariants: ie
    };
  },
  mounted() {
  },
  computed: {
    updateCookieAndStylesScriptStr() {
      var e;
      return Li(
        ie(this.content).map((t) => ({
          id: t.testVariationId,
          testRatio: t.testRatio
        })),
        ((e = this.content) == null ? void 0 : e.id) || ""
      );
    },
    hideVariantsStyleString() {
      return ie(this.content).map((e) => `.variant-${e.testVariationId} { display: none; } `).join("");
    },
    defaultContent() {
      var e;
      return this.shouldRenderVariants ? {
        ...this.content,
        testVariationId: (e = this.content) == null ? void 0 : e.id
      } : Un({
        item: this.content,
        canTrack: G(this.canTrack)
      });
    }
  }
});
function us(e, t, n, o, r, i) {
  const s = k("InlinedScript"), l = k("InlinedStyles"), a = k("ContentComponent");
  return d(), h(I, null, [
    !e.isNestedRender && e.TARGET !== "reactNative" ? (d(), h(I, { key: 0 }, [
      E(s, {
        id: "builderio-init-variants-fns",
        scriptStr: e.getInitVariantsFnsScriptString(),
        nonce: e.nonce || ""
      }, null, 8, ["scriptStr", "nonce"]),
      e.SDKS_SUPPORTING_PERSONALIZATION.includes(e.TARGET) ? (d(), S(s, {
        key: 0,
        id: "builderio-init-personalization-variants-fns",
        nonce: e.nonce || "",
        scriptStr: e.getInitPersonalizationVariantsFnsScriptString()
      }, null, 8, ["nonce", "scriptStr"])) : C("", !0)
    ], 64)) : C("", !0),
    e.shouldRenderVariants ? (d(), h(I, { key: 1 }, [
      E(l, {
        id: "builderio-variants",
        styles: e.hideVariantsStyleString,
        nonce: e.nonce || ""
      }, null, 8, ["styles", "nonce"]),
      E(s, {
        id: "builderio-variants-visibility",
        scriptStr: e.updateCookieAndStylesScriptStr,
        nonce: e.nonce || ""
      }, null, 8, ["scriptStr", "nonce"]),
      (d(!0), h(I, null, F(e.getVariants(e.content), (u, p) => (d(), S(a, $({
        key: u.testVariationId,
        apiHost: e.apiHost,
        isNestedRender: e.isNestedRender,
        nonce: e.nonce,
        content: u,
        showContent: !1,
        model: e.model,
        data: e.data,
        context: e.context,
        apiKey: e.apiKey,
        apiVersion: e.apiVersion,
        customComponents: e.customComponents,
        linkComponent: e.linkComponent,
        canTrack: e.canTrack,
        locale: e.locale,
        enrich: e.enrich,
        isSsrAbTest: e.shouldRenderVariants,
        blocksWrapper: e.blocksWrapper,
        blocksWrapperProps: e.blocksWrapperProps,
        contentWrapper: e.contentWrapper,
        contentWrapperProps: e.contentWrapperProps,
        trustedHosts: e.trustedHosts
      }, {}), null, 16, ["apiHost", "isNestedRender", "nonce", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"]))), 128))
    ], 64)) : C("", !0),
    E(a, $({
      apiHost: e.apiHost,
      nonce: e.nonce,
      isNestedRender: e.isNestedRender,
      content: e.defaultContent,
      showContent: !0,
      model: e.model,
      data: e.data,
      context: e.context,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      customComponents: e.customComponents,
      linkComponent: e.linkComponent,
      canTrack: e.canTrack,
      locale: e.locale,
      enrich: e.enrich,
      isSsrAbTest: e.shouldRenderVariants,
      blocksWrapper: e.blocksWrapper,
      blocksWrapperProps: e.blocksWrapperProps,
      contentWrapper: e.contentWrapper,
      contentWrapperProps: e.contentWrapperProps,
      trustedHosts: e.trustedHosts
    }, {
      key: e.shouldRenderVariants.toString()
    }), null, 16, ["apiHost", "nonce", "isNestedRender", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"])
  ], 64);
}
const ps = /* @__PURE__ */ v(ds, [["render", us]]), ms = async ({
  builderContextValue: e,
  symbol: t
}) => {
  if (t != null && t.model && // This is a hack, we should not need to check for this, but it is needed for Svelte.
  (e != null && e.apiKey))
    return Ee({
      model: t.model,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      ...(t == null ? void 0 : t.entry) && {
        query: {
          id: t.entry
        }
      }
    }).catch((n) => {
      B.error("Could not fetch symbol content: ", n);
    });
}, hs = y({
  name: "builder-symbol",
  components: { ContentVariants: ps, DynamicDiv: te },
  props: [
    "symbol",
    "builderComponents",
    "attributes",
    "dynamic",
    "builderContext",
    "builderBlock",
    "builderLinkComponent"
  ],
  data() {
    var e, t;
    return {
      contentToUse: (e = this.symbol) == null ? void 0 : e.content,
      symbolEntry: (t = this.symbol) == null ? void 0 : t.entry,
      filterAttrs: x
    };
  },
  mounted() {
    this.setContent();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.setContent();
      },
      immediate: !0
    }
  },
  computed: {
    blocksWrapper() {
      return "div";
    },
    contentWrapper() {
      return "div";
    },
    customComponents() {
      return Object.values(this.builderComponents);
    },
    className() {
      var e, t;
      return [
        this.attributes[j()],
        "builder-symbol",
        (e = this.symbol) != null && e.inline ? "builder-inline-symbol" : void 0,
        (t = this.symbol) != null && t.dynamic || this.dynamic ? "builder-dynamic-symbol" : void 0
      ].filter(Boolean).join(" ");
    },
    onUpdateHook0() {
      return {
        0: this.symbol
      };
    }
  },
  methods: {
    setContent() {
      var e;
      this.contentToUse && this.symbolEntry === ((e = this.symbol) == null ? void 0 : e.entry) || ms({
        symbol: this.symbol,
        builderContextValue: this.builderContext
      }).then((t) => {
        var n;
        t && (this.contentToUse = t, this.symbolEntry = (n = this.symbol) == null ? void 0 : n.entry);
      });
    }
  }
});
function fs(e, t, n, o, r, i) {
  var l, a, u, p, f;
  const s = k("ContentVariants");
  return d(), h("div", $({ class: e.className }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, L(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    E(s, {
      nonce: e.builderContext.nonce,
      isNestedRender: !0,
      apiVersion: e.builderContext.apiVersion,
      apiKey: e.builderContext.apiKey,
      context: {
        ...e.builderContext.context,
        symbolId: (l = e.builderBlock) == null ? void 0 : l.id
      },
      customComponents: e.customComponents,
      data: {
        ...(a = e.symbol) == null ? void 0 : a.data,
        ...e.builderContext.localState,
        ...(p = (u = e.contentToUse) == null ? void 0 : u.data) == null ? void 0 : p.state
      },
      canTrack: e.builderContext.canTrack,
      model: ((f = e.symbol) == null ? void 0 : f.model) ?? "",
      content: e.contentToUse,
      linkComponent: e.builderLinkComponent,
      blocksWrapper: e.blocksWrapper,
      contentWrapper: e.contentWrapper
    }, null, 8, ["nonce", "apiVersion", "apiKey", "context", "customComponents", "data", "canTrack", "model", "content", "linkComponent", "blocksWrapper", "contentWrapper"])
  ], 16);
}
const bs = /* @__PURE__ */ v(hs, [["render", fs]]);
export {
  ws as A,
  Ct as B,
  Po as C,
  $s as D,
  Qn as E,
  No as F,
  Yn as G,
  Ee as H,
  Ho as I,
  vs as J,
  As as K,
  Ko as S,
  R as T,
  Bi as V,
  v as _,
  j as a,
  be as b,
  ue as c,
  K as d,
  ee as e,
  $o as f,
  Es as g,
  Rs as h,
  A as i,
  Ps as j,
  Ae as k,
  pn as l,
  Ft as m,
  bs as n,
  Vr as o,
  q as p,
  ps as q,
  Te as r,
  Is as s,
  mn as t,
  Ss as u,
  ks as v,
  ss as w,
  Cs as x,
  tt as y,
  Ts as z
};
